export const FR = {
  AactivityOnboarding: {
    SUMMARY: {
      ACTIVITY_TEXT: 'Fréquence de sortie'
    }
  },
  CANCEL_SUBSCRIPTION: {
    FIRST_SCREEN_XSXTmention: '*Pour les traceurs XS et XT seulement'
  },
  HipayPayments: {
    CARDNUMBER: 'Numéro de carte',
    EXPIRYDATE: 'Date d\'expiration',
    FULLNAME: 'Nom complet',
    GOCARDLESS_LINK: 'Payer par prélèvement bancaire',
    YOURNAME: 'Votre nom'
  },
  Slider: {
    GPS_INTERVAL: 'Intervalle GPS',
    GPS_POSITION_REPORT_ENABLED: 'Remontée des positions GPS activée',
    TRACKER_INTERVAL_TEXT_WARNING: 'En désactivant la remontée automatique des positions GPS vous augmentez la durée de vie de la batterie. Vous pouvez demander une nouvelle position manuellement, mais les zones de sécurité et l\'historique ne fonctionnent plus. '
  },
  TypeSwitch: {
    ANIMAL_SUBTITLE: 'Choisissez l’animal pour lequel vous avez acheté ce traceur :',
    CAT_TYPE: 'Traceur chat',
    DOG_TYPE: 'Traceur chien',
    FAMILY_SUBTITLE: 'Pour qui avez-vous acheté ce traceur ?',
    KID_TYPE: 'Un enfant',
    SILVER_TYPE: 'Un senior',
    TITLE: 'Pour qui est le traceur ?'
  },
  account: {
    LANGUAGE: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu',
        UPDATE_SUCCESS: 'Langue mise à jour avec succès'
      }
    },
    NAV: {
      LANGUAGE: 'Langue',
      PASSWORD: 'Mot de passe',
      PAYMENTS: 'Paiement et facturation',
      USER_PREFERENCES: 'Préférences',
      USER_PROFILE: 'Profil utilisateur'
    },
    PASSWORD: {
      HEADLINE: 'Changement de mot de passe',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu',
        UPDATE_ERROR_WRONG_PASSWORD: 'Vous avez renseigné le mauvais ancien mot de passe',
        UPDATE_SUCCESS: 'Mot de passe mis à jour avec succès'
      }
    },
    PAYMENTS: {
      HISTORY_HEADLINE: 'Historique des paiements',
      MAIN_HEADLINE: 'Facturation'
    },
    USER_PREFERENCES: {
      EMAIL_PREFERENCES_HEADLINE: 'Préférences des e-mails',
      EMAIL_PREFERENCES_USER_INFO: 'Les préférences seront appliquées à l’adresse e-mail {{user_email}}',
      MAIN_HEADLINE: 'Préférences',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu lors de l\'enregistrement des préférences',
        UPDATE_SUCCESS: 'Préférences mises à jour avec succès'
      },
      METRIC_PREFERENCES_DESCRIPTION: 'Choisissez l’unité de distance utilisée pour votre traceur.',
      METRIC_PREFERENCES_HEADLINE: 'Préférence du système métrique'
    },
    USER_PROFILE: {
      BASIC_INFO_HEADLINE: 'Informations de base',
      BILLING_HEADLINE: 'Adresse de facturation',
      MAIN_HEADLINE: 'Profil utilisateur',
      MARKETING_AGREEMENT_TEXT: 'J\'accepte de recevoir des offres et promotions des partenaires de Weenect',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu',
        UPDATE_SUCCESS: 'Informations mises à jour avec succès'
      },
      METRIC_KM: 'Kilomètres',
      METRIC_MILES: 'Miles',
      PREFERRED_METRIC: 'Système métrique à utiliser :'
    }
  },
  accounttab: {
    CANCEL_CTA: 'Annuler',
    ERROR_EMAIL_ALREADY_USED: 'Cette adresse email est déjà associée à un compte',
    ERROR_FORMAT: 'Désolé, ce format n’est pas valide',
    ERROR_INVALID_CREDENTIALS: 'Mot de passe invalide.',
    ERROR_NETWORK: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
    PASSWORD_CHANGE_SUBTITLE: 'Changement de mot de passe',
    PASSWORD_LENGTH_ERROR: 'Le mot de passe doit contenir au minimum 8 caractères',
    PASSWORD_LENGTH_HELPER: 'Longueur minimum : 8 caractères',
    PASSWORD_NEW_LABEL: 'Nouveau mot de passe',
    PASSWORD_OLD_LABEL: 'Ancien mot de passe',
    PASSWORD_SECTION_TITLE: 'Mot de passe',
    PASSWORD_SECURITY_NOTE: 'Pour votre sécurité, changer votre mot de passe vous déconnectera de tous vos appareils. Vous devrez vous reconnecter avec le nouveau mot de passe.',
    PREF_DISPLAY_THEME_DARK: 'Sombre',
    PREF_DISPLAY_THEME_DESCRIPTION: 'Choisissez le thème d’affichage de votre espace Weenect.',
    PREF_DISPLAY_THEME_LIGHT: 'Clair',
    PREF_DISPLAY_THEME_SYSTEM: 'Système',
    PREF_DISPLAY_THEME_TITLE: 'Thème',
    PREF_EMAILS_COMPANY_NEWS: 'Actualités de l\'entreprise',
    PREF_EMAILS_DESCRIPTION: 'Choisissez le type de mails que vous souhaitez recevoir. Nous vous enverrons uniquement ceux correspondant à vos choix. Les préférences seront appliquées à l\'adresse e-mail {{email}}',
    PREF_EMAILS_NEW_FEATURES: 'Nouvelles fonctionnalités',
    PREF_EMAILS_OFFERS: 'Offres promotionnelles',
    PREF_EMAILS_PARTNERS_CONSENT: 'J\'accepte de recevoir des offres et promotions des partenaires de Weenect',
    PREF_EMAILS_SUBTITLE: 'Préférences des e-mails',
    PREF_EMAILS_SURVEYS_BETA: 'Enquête et Beta tests',
    PREF_METRIC_DESCRIPTION: 'Choisissez l\'unité de distance utilisée pour votre traceur.',
    PREF_METRIC_KM: 'Kilomètres',
    PREF_METRIC_MILES: 'Miles',
    PREF_METRIC_SUBTITLE: 'Préférence du système métrique',
    PREF_SECTION_TITLE: 'Préférences',
    PREF_TRACKING_CONSENT: 'J\'accepte le suivi de l\'ouverture de mes e-mails',
    PREF_TRACKING_DESCRIPTION: 'Le suivi des ouvertures nous aide à mesurer l\'efficacité de nos communications et à adapter la fréquence ainsi que le contenu de nos e-mails.',
    PREF_TRACKING_SUBTITLE: 'Suivi de l\'ouverture des e-mails',
    PREF_WEENECT_ANGELS_DISTANCE_DESCRIPTION: 'Choisissez la distance autour de votre traceur dans laquelle afficher les animaux perdus signalés.',
    PREF_WEENECT_ANGELS_DISTANCE_VALUE: '{{km}} km',
    PREF_WEENECT_ANGELS_NOTIF_CONSENT: 'J\'accepte de recevoir des notifications pour Weenect Angels',
    PREF_WEENECT_ANGELS_NOTIF_DESCRIPTION: 'Voulez-vous recevoir les notifications associées à cette fonctionnalité ?',
    PREF_WEENECT_ANGELS_TITLE: 'Weenect Angels',
    PROFIL_ADDRESS_PLACEHOLDER: 'Adresse',
    PROFIL_BASIC_INFO_SUBTITLE: 'Informations de base',
    PROFIL_BILLING_ADDRESS_SUBTITLE: 'Adresse de facturation',
    PROFIL_CITY_PLACEHOLDER: 'Ville',
    PROFIL_COUNTRY_PLACEHOLDER: 'Pays',
    PROFIL_EMAIL_PLACEHOLDER: 'Adresse email',
    PROFIL_FIRSTNAME_PLACEHOLDER: 'Prénom',
    PROFIL_LASTNAME_PLACEHOLDER: 'Nom',
    PROFIL_PHONE_PLACEHOLDER: 'Numéro de téléphone',
    PROFIL_POSTAL_CODE_PLACEHOLDER: 'Code postal',
    PROFIL_SECTION_TITLE: 'Profil utilisateur',
    SAVE_CTA: 'Enregistrer'
  },
  activity: {
    AVERAGE_SPEED: 'Vitesse moyenne',
    CONTROLS: {
      PAUSE_PLAYING_TITLE: 'Suspendre le film de l\'historique',
      RESUME_PLAYING_TITLE: 'Relancer le film de l\'historique',
      START_PLAYING: 'Lancer',
      START_PLAYING_TITLE: 'Lancer le film de l\'historique',
      STOP_PLAYING: 'Stop',
      STOP_PLAYING_TITLE: 'Arrêter le film de l\'historique',
      TOGGLE_HEATMAP: 'Thermocarte',
      TOGGLE_HEATMAP_TITLE: 'Afficher la thermocarte',
      TOGGLE_PATH: 'Tracé des positions',
      TOGGLE_PATH_TITLE: 'Afficher le tracé des positions'
    },
    DETAIL_TITLE: 'Détail de l\'activité',
    EMPTY_LIST: 'Pas d\'alertes à afficher. Modifiez la période sélectionnée ou vérifiez que le traceur est bien allumé.',
    EVENTS: {
      ALERT: 'Bouton latéral actionné',
      BATTERY: 'Batterie faible - {{battery}}% restant',
      CALL_END: 'Appel SOS fini',
      CALL_REQ: 'Appel SOS demandé',
      ENTERS_GEOFENCE: 'Entrée dans la zone',
      EXIT_GEOFENCE: 'Sortie de la zone',
      FLASH_REQ: 'Flash demandé',
      FREQ_CHANGE: 'Intervalle de temps modifié',
      RING: 'Sonnerie effectuée',
      RING_REQ: 'Sonnerie demandée',
      SOS: 'Alerte SOS',
      TRACKER_OFF: 'Traceur éteint',
      TRACKER_ON: 'Traceur allumé',
      VIBRATE: 'Vibration effectuée',
      VIBRATE_REQ: 'Vibrations demandées'
    },
    FEEDBACKTEXT: {
      FIRST: '{{name}} a eu une activité plus forte {{currentPeriod}} par rapport a {{previousPeriod}}',
      SECOND: '{{name}} a eu une activité moins forte {{currentPeriod}} par rapport {{previousPeriod}}'
    },
    HISTORY_TITLE: 'Historique des notifications',
    LAST_TIME_PERIOD: 'Montrer les dernières',
    LOADING: 'Chargement...',
    MAXIMUM_SPEED: 'Vitesse maximale',
    OBJECTIVE: {
      CONTENT: 'Fixez un objectif d\'activité intense à atteindre chaque jour.',
      DAILY_REACHED: '{{name}} a atteint son objectif journalier !',
      HELPTEXT: 'Seule l\'activité intense est prise en compte dans la mesure de l\'objectif quotidien. Comme une course ou une session de jeux par exemple.',
      RECOMENDED_VALUE: 'Objectif recommandé : 1h',
      SUBTEXT: 'Notre algorithme enregistre chaque mouvement de votre traceur, puis classe les résultats par niveau d\'intensité. Nous déterminons ainsi s\'il s\'agit d\'une activité intense, d\'un moment d\'éveil ou d\'un temps de repos.',
      TITLE: 'Objectif quotidien'
    },
    ONBOARDING: {
      FIRST_SUBTEXT: 'Cet outil va vous permettre de connaître l’activité journalière de votre compagnon.',
      SECOND_SUBTEXT: 'Combien de temps a-t-il dormi ? Combien de pas a-t-il fait aujourd’hui ?',
      START: 'Commencer !',
      THIRD_SUBTEXT: 'Vous pourrez même vous fixer un objectif en fonction de la race de votre animal, afin que celui-ci ait l’activité journalière dont il a besoin.',
      TITLE: 'Bienvenue dans le suivi d’activité Weenect !'
    },
    PROGRESSBAR: {
      TITLE: 'Objectif quotidien'
    },
    REPARTION: {
      DAY: 'Sur la journée en cours. ',
      MONTH: 'sur les 30 derniers jours',
      WEEK: 'sur les 7 derniers jours'
    },
    SELECT_DAY: 'Choisir un jour à afficher',
    SELECT_TIME: 'Utilisez le curseur pour sélectionner la période à afficher',
    SUMMARY: {
      ACTIVITY: 'Intense',
      AWAKENING: 'Modéré',
      DATEINTERVAL: 'Du {{dayFrom}} au {{dayTo}} {{month}}',
      DAY_INDEX: 'j',
      DISTRIBUTIONTEXT: 'Rapport détaillé',
      HOUR_INDEX: 'h',
      LASTWEEK: 'Derniers 7 jours',
      MENU_TITLE: 'Rapport d’activité',
      MIN_INDEX: 'min',
      MODIFY_PERIOD: 'Changer la période',
      PREVIOUS_DAY: 'au jour précédent',
      PREVIOUS_MONTH: 'au mois précédent',
      PREVIOUS_WEEK: 'a la semaine précédente',
      REGISTERED_ACTIVITY: 'pas',
      REPORT: 'Voir le rapport ',
      REST: 'Faible',
      SUBTEXT: 'Encore {{time}} d\'activité intense avant d\'atteindre l\'objectif de {{name}}.',
      TEXT_OBJECTIVE_COMPLETED: '{{name}} a atteint son objectif journalier !',
      TEXT_OBJECTIVE_COMPLETED_TREAT: 'Félicitations, {{name}} a rempli son objectif ! Cela mérite peut-être une petite friandise ?',
      TEXT_OBJECTIVE_NONE: '{{name}} n’a pas encore de données pour aujourd’hui.',
      TEXT_OBJECTIVE_NONE_VERIFY_TRACKER: '{{name}} n’a pas encore enregistré de mouvements. Vérifiez que votre traceur est bien allumé et la batterie chargée !',
      TITTLE: 'Progression de {{name}}',
      TODAY: 'Aujourd’hui,',
      TOTAL: 'Total',
      YESTERDAY: 'Hier'
    },
    TIME_ELAPSED: 'Durée',
    TOTAL_DISTANCE: 'Distance totale'
  },
  activityGeneral: {
    BEHAVIOR: 'Activité ',
    STANDARD_MORPHOLOGY: 'Morphologie ',
    STERILIZED: 'Stérilisé'
  },
  activityOnboarding: {
    COMMON: {
      STEP: 'Etape',
      TRACKER_PROFIL: 'Profil du traceur\n'
    },
    MONTH: {
      APRIL: 'Avril',
      AUGUST: 'Août',
      DECEMBER: 'Décembre',
      FEBRUARY: 'Février',
      JANUARY: 'Janvier',
      JULY: 'Juillet',
      JUNE: 'Juin',
      MARCH: 'Mars',
      MAY: 'Mai',
      NOVEMBER: 'Novembre',
      OCTOBER: 'Octobre',
      SEPTEMBER: 'Septembre'
    },
    PET_ACTIVITY: {
      FIRST_BUTTON: 'Casanier (le strict minimum)',
      FIRST_BUTTON_CAT: 'Exceptionnellement (vacances, imprévus...)',
      FIRST_BUTTON_DOG: 'Pour ses besoins uniquement',
      FOURTH_BUTTON: 'Hyperactif (2 à 3 balades par jour)',
      FOURTH_BUTTON_CAT: 'Régulièrement, de jour comme de nuit ',
      FOURTH_BUTTON_DOG: '2 à 3 balades/ jour',
      SECOND_BUTTON: 'Normal (2 à 3 balades par semaine)',
      SECOND_BUTTON_CAT: 'De temps en temps, à sa demande ',
      SECOND_BUTTON_DOG: '2 à 3 balades/semaine',
      SELECT_ACTIVITY: 'A quelle fréquence sort-il ?',
      THIRD_BUTTON: 'Énergique (une balade par jour)',
      THIRD_BUTTON_CAT: 'Régulièrement, en journée\n',
      THIRD_BUTTON_DOG: 'Une balade par jour',
      TITLE: 'Quel est son profil sportif ?'
    },
    PET_AGE: {
      FIRST_COMMON_TEXT: 'an(s) et ',
      SECOND_COMMON_TEXT: 'mois',
      TITLE: 'Quelle est sa date de naissance ?'
    },
    PET_GENDER: {
      FEMALE: 'Une femelle',
      FIRST_TITLE: 'Quel est le genre de votre animal ?',
      MALE: 'Un mâle',
      SECOND_TITLE: 'Votre animal est-il stérilisé ?'
    },
    PET_HEALTH: {
      LAST_VACINATION: 'Et son dernier vaccin ?',
      LAST_VET_VISIT: 'De quand date sa dernière visite chez le vétérinaire ?  ',
      TITLE: 'Point santé'
    },
    PET_IDENTIFICATION: {
      CHIP: 'Pucé',
      NONE: 'Mon animal n’est pas identifié',
      SELECT_IDENTIFICATION: 'Comment est-il identifié ? ',
      TATTOO: 'Tatoué'
    },
    PET_INFO: {
      GET_STARTED: 'C’est parti !',
      NEED_TO_KNOW: 'Il est important pour nous d’apprendre à connaître  {{name}} .',
      PETS_DETAILS: 'Remplissez les informations de votre animal !',
      PETS_GENDER: {
        MIXED_BREED: 'C’est un croisé'
      },
      PET_GENDER_COMMON: 'Pour commencer, votre animal est : ',
      SECOND_PETS_DETAILS: 'Renseignez les informations de votre compagnon'
    },
    PET_MORPH: {
      AVERAGE: 'Normale',
      COMMON_TEXT: 'Environ',
      FIRST_TITLE: 'Quelle est sa morphologie ?',
      HELP_TEXT: 'Comment définir la morphologie de mon animal ?\n',
      LEAN: 'Maigre',
      OBESE: 'Obèse',
      OVERWEIGHT: 'En surpoids',
      SECOND_TITLE: 'Quel est son poids ?',
      WEIGH_TEXT: 'Combien pèse votre animal ?'
    },
    PET_NAME: {
      COMMON_TEXT: 'Faisons connaissance avec votre boule de poils ! Vous pourrez ensuite modifier ces informations dans les paramètres. ',
      PLACEHOLDER: 'Nom de votre animal',
      TITLE: 'Comment s’appelle-t-il ?'
    },
    PET_RACE: {
      COMMON_TEXT: 'Je ne connais pas sa race',
      PLACEHOLDER: 'Quelle est la race de votre chien? ',
      SELECT_BREED: 'Sélectionnez sa race',
      TITLE: 'Quelle est la race de votre animal? '
    },
    PET_TYPE: {
      CAT: 'Un chat',
      DOG: 'Un chien'
    },
    SUMMARY: {
      BIRTH_DATE: 'Date de naissance',
      BREED: 'Race',
      CONDITION: 'Etat',
      DAILY_EXERCISE: 'Dépense quotidienne',
      DELETE: 'Réinitialiser le profil',
      HEALTH: 'Santé',
      IDENTIFICATION: 'Identification',
      MODAL: {
        NO: 'Non, annuler',
        SUBTEXT: 'Vous devrez ensuite recommencer à 0 le processus.',
        TITLE: 'Êtes-vous sûr de vouloir réinitialiser les informations de votre animal ?',
        YES: 'Oui je suis sûr'
      },
      MORPHOLOGY: 'Morphologie',
      NAME: 'Nom',
      RECAPTEXT: 'Voici les informations renseignées sur votre compagnon.',
      SEX: 'Sexe',
      SPECIES: 'Espèce',
      SUBMIT: 'Valider le profil',
      UNSPECIFIED: 'non renseignées',
      VALIDATION: 'Validation du profil',
      VALIDATION_TEXT: 'Veuillez valider vos informations avant de continuer. ',
      WEIGHT: 'Poids'
    }
  },
  activityTracking: {
    ACTIVITY: 'd\'activité',
    ACTIVITY_DISTRIBUTION: {
      DATA_COMPARATOR: {
        ACTIVITY_INTENSE: 'Activité intense',
        ACTIVITY_INTENSE_LEGEND: 'd\'activité intense {{day}}',
        ACTIVITY_INTENSE_LEGEND1_DAY: 'd\'activité intense hier',
        ACTIVITY_INTENSE_LEGEND1_MONTH: 'd\'activité intense ce mois-ci',
        ACTIVITY_INTENSE_LEGEND1_WEEK: 'd\'activité intense cette semaine',
        ACTIVITY_INTENSE_LEGEND2_DAY: 'd\'activité intense avant-hier',
        ACTIVITY_INTENSE_LEGEND2_MONTH: 'd\'activité intense le mois dernier',
        ACTIVITY_INTENSE_LEGEND2_WEEK: 'd\'activité intense la semaine dernière',
        ACTIVITY_LOW_LEGEND1_DAY: 'd\'activité faible hier',
        ACTIVITY_LOW_LEGEND1_MONTH: 'd\'activité faible ce mois-ci',
        ACTIVITY_LOW_LEGEND1_WEEK: 'd\'activité faible cette semaine',
        ACTIVITY_LOW_LEGEND2_DAY: 'd\'activité faible avant-hier',
        ACTIVITY_LOW_LEGEND2_MONTH: 'd\'activité faible le mois dernier',
        ACTIVITY_LOW_LEGEND2_WEEK: 'd\'activité faible la semaine dernière',
        ACTIVITY_MODERATE: 'Activité modérée',
        ACTIVITY_MODERATE_LEGEND: 'd\'activité modérée {{day}}',
        ACTIVITY_MODERATE_LEGEND1_DAY: 'd\'activité modérée hier',
        ACTIVITY_MODERATE_LEGEND1_MONTH: 'd\'activité modérée ce mois-ci',
        ACTIVITY_MODERATE_LEGEND1_WEEK: 'd\'activité modérée cette semaine',
        ACTIVITY_MODERATE_LEGEND2_DAY: 'd\'activité modérée avant-hier',
        ACTIVITY_MODERATE_LEGEND2_MONTH: 'd\'activité modérée le mois dernier',
        ACTIVITY_MODERATE_LEGEND2_WEEK: 'd\'activité modérée la semaine dernière',
        ACTIVITY_WEAK: 'Activité faible',
        ACTIVITY_WEAK_LEGEND: 'd\'activité faible {{day}}',
        TEXT: '{{petName}} a eu une activité {{activity}} {{comparator}} longue hier que {{day}}.'
      }
    },
    ACTIVITY_REPORT: {
      DATA_COMPARATOR: {
        LEGEND: {
          KM_MONTHLY: 'kilomètres quotidiens en moyenne ce mois-ci',
          KM_WEEKLY: 'kilomètres quotidiens en moyenne cette semaine',
          KM_YESTERDAY: 'kilomètres parcourus sur la journée d\'hier',
          STEP_MONTHLY: 'pas quotidiens en moyenne ce mois-ci',
          STEP_WEEKLY: 'pas quotidiens en moyenne cette semaine',
          STEP_YESTERDAY: 'pas effectués sur la journée d\'hier'
        },
        LEGEND1: {
          STEP_DAY: 'pas effectués sur la journée d’hier',
          STEP_MONTH: 'pas quotidiens en moyenne cette semaine',
          STEP_WEEK: 'pas effectués hier'
        },
        LEGEND2: {
          STEP_DAY: 'pas effectués sur la journée d\'avant-hier',
          STEP_MONTH: 'pas quotidiens en moyenne ce mois-ci',
          STEP_WEEK: 'pas quotidiens en moyenne les 7 jours précédents'
        },
        TEXT_INF: 'inférieur',
        TEXT_KM_DAILY: 'Le nombre de kilomètres parcourus hier par {{petName}} est {{comparator}} à celui parcouru avant-hier.',
        TEXT_KM_MONTHLY: 'Le nombre moyen de kilomètres parcourus cette semaine par {{petName}} est {{comparator}} à celui du mois en cours.',
        TEXT_KM_WEEKLY: 'Le nombre de kilomètres parcourus hier par {{petName}} est {{comparator}} à sa moyenne hebdomadaire.',
        TEXT_SIM: 'similaire',
        TEXT_STEP_DAILY: 'Le nombre de pas effectués hier par {{petName}} est {{comparator}} à celui d’avant-hier.',
        TEXT_STEP_MONTHLY: 'Le nombre moyen de pas effectués cette semaine par {{petName}} est {{comparator}} à celui du mois en cours.',
        TEXT_STEP_WEEKLY: 'Le nombre de pas effectués hier par {{petName}} est {{comparator}} à sa moyenne hebdomadaire.',
        TEXT_SUP: 'supérieur',
        TITLE_KM_TRAVELED: 'Kilomètres parcourus',
        TITLE_STEP: 'Pas effectués'
      },
      KM_TRAVELED: '{{step}} kilomètres parcourus'
    },
    AIMED_GOAL: {
      ALERT: 'Nous recommandons un objectif quotidien d\'au moins 3 heures, afin de maintenir votre animal en bonne santé.',
      TITLE: 'Fixez un objectif d\'activité à atteindre chaque jour.'
    },
    DAILY_CHART: 'Activité de {{petName}}',
    DAILY_GOAL: {
      NOT_RECOMMENDED: 'Objectif déconseillé ',
      RECOMMENDED: 'Objectif recommandé',
      SECOND_TITLE: 'Objectif quotidien',
      TITLE: 'Objectif quotidien'
    },
    DAILY_STEP: 'Pas journalier',
    DAYS: 'jour',
    EQUAL: 'aussi',
    ERROR_PAGE: {
      BUTTON_TEXT: 'Fermer la page',
      TEXT: 'Nous ne pouvons pas charger la page actuellement. Veuillez réessayer plus tard.',
      TITLE: 'Oups, nous avons rencontré un problème...'
    },
    HEADER: {
      ACTIVITY_DISTRIBUTION: {
        TITLE: 'Répartition de l’activité'
      },
      ACTIVITY_REPORT: {
        TITLE: 'Rapports d\'activité'
      },
      GOAL: {
        TITLE: 'Objectif quotidien'
      }
    },
    HOME: {
      ACTIVITY_DISTRIBUTION: {
        INTENSE: 'Intense',
        MODERATE: 'Modéré',
        WEAK: 'Faible'
      },
      ALERT: 'Quelques jours d\'apprentissage sont nécessaires pour garantir des données fiables. Pendant cette période, l\'algorithme collecte et analyse vos données afin de comprendre les habitudes et schémas d\'activité de votre animal. Avec le temps, les résultats deviendront de plus en plus précis et adaptés à son profil.',
      FIRST_SECTION: {
        TITLE: 'Objectif quotidien'
      },
      INSURANCE: {
        BUTTON: 'Découvrir Weenect Assurance',
        TEXT: 'Une visite chez le vétérinaire s\'impose. Faites confiance à Weenect pour le remboursement de votre consultation.'
      },
      MODIFY: 'Modifier',
      PROFILE: {
        SUBTITLE: 'Contrôlez son activité quotidienne, afin de le maintenir en forme.'
      },
      SECOND_SECTION: {
        SUBTITLE: 'Sur la journée en cours.',
        TITLE: 'Répartition'
      },
      SEE_MORE: 'Voir plus',
      THIRD_SECTION: {
        TITLE: 'Points clés'
      }
    },
    HOUR: '{{count}} h',
    HOURS: 'Heures',
    INTERVAL: {
      TEXT: 'Déplacez les bords du graphique pour changer la période affichée.',
      TITLE: 'Sélection de la période'
    },
    KEY_POINTS: 'Points clés',
    KILOMETERS: 'Kilomètres',
    LESS: 'moins',
    MIN: 'Minutes',
    MINUTE_ACTIVITY_one: '{{count}} minute d\'activité',
    MINUTE_ACTIVITY_other: '{{count}} minutes d\'activité',
    MINUTE_one: '{{count}} minute',
    MINUTE_other: '{{count}} minutes',
    MIN_one: '{{count}} min',
    MIN_other: '{{count}} min',
    MONTHLY_STEP: 'Pas mensuel',
    ONBOARDING: {
      FIRST_STEP: {
        ALERT: 'En mode avion, l\'activité continue d\'être enregistrée. Elle apparaît dans le tableau de bord dès la sortie de la zone wifi.',
        BUTTON: 'Commencer',
        MESSAGE: 'Cet outil vous permet de suivre l’activité quotidienne de votre boule de poils.  Combien de temps a-t-il dormi ? Combien de pas a-t-il faits aujourd’hui ? Tout ceci n’aura bientôt plus de secret pour vous !',
        TITLE: 'Bienvenue sur le suivi d’activité de votre animal !'
      },
      SECONDE_STEP: {
        BUTTON: 'Enregistrer',
        PROFILE: {
          SUBTITLE: 'Contrôlez son activité quotidienne, afin de le maintenir en forme.',
          TITLE: 'Activité de {{petName}}'
        },
        TITLE: 'Fixez un objectif d\'activité à atteindre chaque jour.'
      }
    },
    PERIOD: {
      DAY: 'Jour',
      MONTH: 'Mois',
      TITLE: 'Sélection de la période',
      WEEK: 'Semaine',
      YEAR: 'Année'
    },
    PLUS: 'plus',
    RETURN_HOME: 'Retour a l\'accueil',
    STEP: 'Pas',
    STEP_SAVED: '{{step}} pas',
    TEXT: 'Ce graphique vous indique l\'évolution de l\'activité réalisée par votre animal. La mesure de cette activité se fait sur un intervalle partant de 0 et n\'ayant pas de limite maximum. Chaque point d\'activité représente une accélération, c\'est a dire un mouvement de votre animal.',
    TITLE_DAY: 'Aujourd\'hui, {{DATE}} ',
    TITLE_MONTH: 'Mois du {{DAY1}} au {{DAY2}} ',
    TITLE_WEEK: 'Semaine du {{DAY1}} au {{DAY2}} ',
    TOTAL: 'Total',
    WEEKDAYS: {
      FRIDAY: 'Vendredi',
      FRIDAY_COMPARATIVE: 'vendredi',
      MONDAY: 'Lundi',
      MONDAY_COMPARATIVE: 'lundi',
      SATURDAY: 'Samedi',
      SATURDAY_COMPARATIVE: 'samedi',
      SUNDAY: 'Dimanche',
      SUNDAY_COMPARATIVE: 'dimanche',
      THURSDAY: 'Jeudi',
      THURSDAY_COMPARATIVE: 'jeudi',
      TUESDAY: 'Mardi',
      TUESDAY_COMPARATIVE: 'mardi',
      WEDNESDAY: 'Mercredi',
      WEDNESDAY_COMPARATIVE: 'mercredi'
    },
    WEEKLY_STEP: 'Pas hebdomadaire',
    YESTERDAY: 'hier'
  },
  address: {
    CITY_PLACEHOLDER: 'Ville',
    COUNTRY_PLACEHOLDER: 'Pays',
    LANGUAGE_PLACEHOLDER: 'Langue',
    POSTAL_CODE_PLACEHOLDER: 'Code postal',
    STREET_PLACEHOLDER: 'N° et voie',
    SUBMIT_CTA: 'Continuer',
    TITLE: 'Quelle est votre adresse ?'
  },
  alertCustomer: {
    BODY0: 'Une maintenance est actuellement en cours chez notre fournisseur de carte SIM.',
    BODY1: 'Pendant cette maintenance <1>le délai d\'activation des cartes SIM est allongé à 24h</1>.',
    BODY2: 'Nous sommes bien conscients de la gêne que cela représente, nous vous prions de nous excuser pour ce problème indépendant de notre volonté.\n\nPour plus d\'informations, vous pouvez contacter notre équipe à l\'adresse mail <1>family@weenect.com</1> ou par téléphone au 01.87.66.00.83.',
    FOOTER: 'L\'équipe Weenect'
  },
  animalInfo: {
    ERROR: 'Erreur',
    LANDING_PAGE: {
      BUTTON: 'Commencer',
      TEXT: 'Faisons connaissance avec votre boule de poils. Vous pourrez ensuite modifier ces informations dans les paramètres. ',
      TITLE: 'Renseignez les informations de votre compagnon !',
      WARNING: 'Ces informations nous sont nécessaires pour que le suivi d’activité soit le plus précis possible, ainsi que pour personnaliser votre expérience Weenect.'
    },
    NEXT_BUTTON: 'Suivant',
    PROFIL_VALIDATION: {
      ACTIVITY: 'Activité et comportement',
      BUTTON: 'Valider le profil',
      ERROR: 'Erreur',
      INDENTIFICATION_INFOS: 'Infos d’identification',
      MEDICAL_HISTORY: 'Historique médical',
      PERSONAL_INFOS: 'Infos personnelles',
      PHYSICAL: 'Caractéristiques physiques',
      SEX: 'Sexe',
      SPECIES: 'Espèce',
      TITLE: 'Validation du profil',
      UNIQUE_IDENTIFICATION: 'Identification unique'
    },
    QUESTION: 'Question',
    QUESTION_EIGHT: {
      NO: 'Non',
      NOT_STERILIZED: 'Non stérilisé',
      QUESTION: 'Votre animal est-il stérilisé ?',
      STERILIZATION_STATUS: 'Statut de stérilisation',
      STERILIZED: 'Stérilisé',
      YES: 'Oui'
    },
    QUESTION_ELEVEN: {
      EVERYTIME: 'Souvent',
      EXIT_FREQUENCY: 'Fréquence de sortie',
      MOSTLY: 'De temps en temps',
      OFTEN: 'Régulièrement',
      QUESTION: 'A quelle fréquence sort-il ?',
      RARELY: 'Exceptionnellement'
    },
    QUESTION_FIVE: {
      QUESTION: 'Combien pèse votre animal ?',
      WEIGHT: 'Poids'
    },
    QUESTION_FOUR: {
      FEMALE: 'Femelle',
      MALE: 'Mâle',
      QUESTION: 'Quel est le sexe de votre animal ?'
    },
    QUESTION_NINE: {
      LAST_VISIT: 'Dernière visite',
      QUESTION: 'De quand date sa dernière visite chez le vétérinaire ?'
    },
    QUESTION_ONE: {
      CAT: 'Un chat',
      DOG: 'Un chien',
      QUESTION: 'Quel est le profil de votre animal ?'
    },
    QUESTION_SEVEN: {
      CHIPED: 'Pucé',
      IDENTIFICATION: 'Identification',
      NOT_IDENTIFIED: 'Mon animal n’est pas identifié',
      QUESTION: 'Comment est-il identifié ?',
      TATTOED: 'Tatoué'
    },
    QUESTION_SIX: {
      QUESTION: 'Quelle est la race de votre animal ?',
      RACE: 'Race'
    },
    QUESTION_TEN: {
      LAST_VACCIN: 'Dernier vaccin',
      QUESTION: 'Et son dernier vaccin ?'
    },
    QUESTION_THREE: {
      BIRTHDATE: 'Date de naissance',
      QUESTION: 'Quelle est sa date de naissance?'
    },
    QUESTION_TWO: {
      NAME: 'Nom',
      QUESTION: 'Comment s’appelle-t-il ?'
    },
    santevet: {
      description: 'Protégez {{animal_name}} avec le numéro 1 de l’Assurance Santé pour chiens et chats. ',
      optin: 'J’accepte d\'être contacté par Santévet pour profiter de mes 3 premiers mois offerts.',
      title: '3 mois offerts !'
    }
  },
  animalinfo: {
    AUTO_ADVANCE_HINT: 'Cliquez sur une réponse : vous passerez directement à la question suivante.',
    BACK: 'Retour',
    BIRTH_AGE_MONTHS: 'soit {{count}} mois',
    BIRTH_AGE_YEAR: 'soit {{count}} an',
    BIRTH_AGE_YEARS: 'soit {{count}} ans',
    BIRTH_APPROX_1_3: '1 à 3 ans',
    BIRTH_APPROX_4_7: '4 à 7 ans',
    BIRTH_APPROX_8_PLUS: '8 ans et plus',
    BIRTH_APPROX_LESS_1: 'Moins d’1 an',
    BIRTH_APPROX_SUBTITLE: 'Indiquez son âge approximatif :',
    BIRTH_APPROX_TITLE: 'Vous ne connaissez pas la date exacte ?',
    BIRTH_DAY: 'Jour',
    BIRTH_DAY_PLACEHOLDER: 'JJ',
    BIRTH_ERROR_FUTURE: 'La date de naissance ne peut pas être dans le futur.',
    BIRTH_ERROR_INVALID: 'Cette date n’existe pas.',
    BIRTH_MONTH: 'Mois',
    BIRTH_MONTH_PLACEHOLDER: 'MM',
    BIRTH_TITLE_FEMALE: 'Quand est née {{name}} ?',
    BIRTH_TITLE_MALE: 'Quand est né {{name}} ?',
    BIRTH_YEAR: 'Année',
    BIRTH_YEAR_PLACEHOLDER: 'AAAA',
    BREED_MIXED: 'Croisé',
    BREED_NO_PRECISE: 'Pas de race précise ?',
    BREED_NO_RESULT: 'Aucune race trouvée. Essayez un autre nom ou choisissez « Croisé ».',
    BREED_SEARCH_PLACEHOLDER: 'Rechercher une race',
    BREED_TITLE: 'Quelle est sa race ?',
    BREED_UNKNOWN: 'Je ne sais pas',
    CLOSE: 'Fermer',
    CONTINUE: 'Continuer',
    ERROR_GENERIC: 'Une erreur est survenue. Réessayez.',
    GENDER_FEMALE: 'Une femelle',
    GENDER_MALE: 'Un mâle',
    GENDER_TITLE: '{{name}} est…',
    HEADER_TITLE: 'Profil de {{name}}',
    IDENTIFICATION_CHIP_DESC: 'Puce électronique sous la peau',
    IDENTIFICATION_CHIP_FEMALE: 'Pucée',
    IDENTIFICATION_CHIP_MALE: 'Pucé',
    IDENTIFICATION_CHIP_NUMBER_HELP_FEMALE: 'Utile pour l’identifier plus vite si elle se perd. 15 chiffres, sur son carnet de santé ou sa carte d’identification.',
    IDENTIFICATION_CHIP_NUMBER_HELP_MALE: 'Utile pour l’identifier plus vite s’il se perd. 15 chiffres, sur son carnet de santé ou sa carte d’identification.',
    IDENTIFICATION_CHIP_NUMBER_LABEL: 'Numéro de puce (facultatif)',
    IDENTIFICATION_NONE: 'Ni l’un ni l’autre',
    IDENTIFICATION_NONE_DESC: 'Ou je ne sais pas',
    IDENTIFICATION_TATTOO_DESC: 'Tatouage à l’oreille ou à la cuisse',
    IDENTIFICATION_TATTOO_FEMALE: 'Tatouée',
    IDENTIFICATION_TATTOO_MALE: 'Tatoué',
    IDENTIFICATION_TATTOO_NUMBER_HELP_FEMALE: 'Utile pour l’identifier plus vite si elle se perd. Tel qu’inscrit sur sa carte d’identification.',
    IDENTIFICATION_TATTOO_NUMBER_HELP_MALE: 'Utile pour l’identifier plus vite s’il se perd. Tel qu’inscrit sur sa carte d’identification.',
    IDENTIFICATION_TATTOO_NUMBER_LABEL: 'Numéro de tatouage (facultatif)',
    IDENTIFICATION_TATTOO_NUMBER_PLACEHOLDER: 'Lettres et chiffres',
    IDENTIFICATION_TITLE_FEMALE: '{{name}} est-elle identifiée ?',
    IDENTIFICATION_TITLE_MALE: '{{name}} est-il identifié ?',
    INTRO_CTA: 'C’est parti',
    INTRO_INFO: 'Ces informations rendent le suivi d’activité de {{name}} plus précis et personnalisent votre expérience Weenect.',
    INTRO_SUBTITLE: '6 questions rapides. Tout reste modifiable ensuite dans son profil.',
    INTRO_TITLE: 'Faisons connaissance avec {{name}}',
    NEUTERING_TITLE_FEMALE: '{{name}} est-elle stérilisée ?',
    NEUTERING_TITLE_MALE: '{{name}} est-il stérilisé ?',
    NO: 'Non',
    PROGRESS: 'Question {{current}} sur {{total}}',
    RECAP_BIRTH_APPROX: 'Âge approximatif : {{range}}',
    RECAP_BREED_UNKNOWN: 'Inconnue',
    RECAP_CTA: 'Valider le profil',
    RECAP_EDIT: 'Modifier',
    RECAP_FEMALE: 'Femelle',
    RECAP_HEADER: 'Vérification',
    RECAP_IDENTIFICATION_NONE: 'Aucune',
    RECAP_LABEL_BIRTH: 'Date de naissance',
    RECAP_LABEL_BREED: 'Race',
    RECAP_LABEL_GENDER: 'Sexe',
    RECAP_LABEL_IDENTIFICATION: 'Identification',
    RECAP_LABEL_NEUTERING_FEMALE: 'Stérilisée',
    RECAP_LABEL_NEUTERING_MALE: 'Stérilisé',
    RECAP_LABEL_VET: 'Dernière visite véto',
    RECAP_MALE: 'Mâle',
    RECAP_SUBTITLE: 'Vérifiez ses informations avant de valider.',
    RECAP_TITLE: 'Tout est bon pour {{name}} ?',
    RECAP_VET_UNKNOWN: 'Non renseignée',
    VET_ERROR_BEFORE_BIRTH: 'Cette date est antérieure à sa naissance.',
    VET_ERROR_FUTURE: 'Cette date ne peut pas être dans le futur.',
    VET_MONTH: 'Mois',
    VET_TITLE_FEMALE: 'Quand a-t-elle vu le vétérinaire pour la dernière fois ?',
    VET_TITLE_MALE: 'Quand a-t-il vu le vétérinaire pour la dernière fois ?',
    VET_UNKNOWN: 'Je ne m’en souviens plus',
    VET_YEAR: 'Année',
    YES: 'Oui'
  },
  breed: {
    CAT: {
      ABYSSINIAN: 'Abyssin',
      AMERICAN_BOBTAIL: 'Americain Bobtail',
      AMERICAN_CURL: 'American Curl',
      AMERICAN_SHORTHAIR: 'American Shorthair',
      AMERICAN_WIREHAIR: 'Américain à poil dur',
      BALINESE: 'Balinais',
      BENGAL: 'Bengal',
      BIRMAN: 'Chat sacré de Birmanie',
      BOMBAY: 'Bombay',
      BURMESE: 'Burmese',
      BURMILLA: 'Burmilla',
      CALIFORNIA_SPANGLED_CAT: 'California Spangled Cat',
      CHANTILLYTIFFANY: 'Tiffany',
      CHARTREUX: 'Chartreux',
      CORNISH_REX: 'Cornish Rex',
      CYMRIC: 'Cymric',
      DEVON_REX: 'Devon Rex',
      EGYPTIAN_MAU: 'Mau égyptien',
      EUROPEAN: 'Européen',
      EXOTIC_SHORTHAIR: 'Exotic Shorthair',
      HAVANA: 'Havana',
      JAPANESE_BOBTAIL: 'Bobtail japonais',
      JAVANESE: 'Javanais',
      KORAT: 'Korat',
      MAINE_COON: 'Maine Coon',
      MALAYAN: 'Malayan',
      MANX: 'Manx',
      MUNCHKIN: 'Munchkin',
      NEBELUNG: 'Nebelung',
      NORWEGIAN: 'Norvégien',
      NORWEGIAN_FOREST_CAT: 'Chat des Forêts norvégiennes',
      OCICAT: 'Ocicat',
      ORIENTAL_LONGHAIR: 'Mandarin',
      ORIENTAL_SHORTHAIR: 'Oriental',
      PERSIAN: 'Persan',
      RAGDOLL: 'Ragdoll',
      RUSSIAN_BLUE: 'Bleu russe',
      SAFARI_CAT: 'Chat Safari',
      SCOTTISH_FOLD: 'Scottish Fold',
      SELKIRK: 'Selkirk',
      SIAMESE: 'Siamois',
      SIBERIAN: 'Sibérien',
      SINGAPURA: 'Singapura',
      SNOWSHOE: 'Snowshoe',
      SOMALI: 'Somali',
      SPHYNX: 'Sphynx',
      THAI: 'Thai',
      TONKINESE: 'Tonkinois',
      TURKISH_ANGORA: 'Angora turc',
      TURKISH_VAN: 'Turc Van'
    },
    DOG: {
      AFFENPINSCHER: 'Affenpinscher',
      AFGHAN_HOUND: 'Lévrier Afghan',
      AIREDALE_TERRIER: 'Airedale Terrier',
      AKITA: 'Akita Inu',
      AKITA_INU_GREAT_JAPANESE_DOG: 'Grand Chien Japonais',
      ALASKAN_MALAMUTE: 'Malamute de l\'Alaska',
      ALPINE_DACHSBRACKE: 'Basset des Alpes',
      AMERICAN_BULLDOG: 'Bouledogue Americain',
      AMERICAN_COCKER_SPANIEL: 'Cocker Américain',
      AMERICAN_FOXHOUND: 'Foxhound Américain',
      AMERICAN_STAFFORDSHIRE_TERRIER: 'American Staffordshire Terrier',
      AMERICAN_WATER_SPANIEL: 'Chien d\'eau Américain',
      ANATOLIAN_SHEPHERD_DOG: 'Berger d\'Anatolie',
      APPENZELLER_SENNENHUND: 'Bouvier d\'Appenzell',
      ARDENNES_CATTLE_DOG: 'Bouvier des Ardennes',
      ARGENTINE_DOGO: 'Dogue Argentin',
      ARIEGEOIS: 'Ariégeois',
      ARIEGE_POINTER: 'Braque de l\'Ariège',
      ARTOIS_HOUND: 'Chien d\'Artois',
      ATLAS_SHEPHERD_DOG_AIDI: 'Chien de l\'Atlas (Aïdi - Berger de l\'Atlas)',
      AUSTRALIAN_CATTLE_DOG: 'Bouvier Australien',
      AUSTRALIAN_KELPIE: 'Berger Australien Kelpie',
      AUSTRALIAN_SHEPHERD: 'Berger Australien d\'Amérique',
      AUSTRALIAN_TERRIER: 'Terrier Australien',
      AUSTRIAN_BLACK_AND_TAN_HOUND: 'Brachet Autrichien Noir et Feu',
      AUSTRIAN_SHORTHAIRED_PINSCHER: 'Pinscher Autrichien à poil court',
      AZAWAKH: 'Azawakh',
      BALKAN_HOUND: 'Chien Courant des Balkans',
      BARBET: 'Barbet',
      BASENJI: 'Basenji',
      BASSET_ARTESIEN_NORMAND: 'Basset Artésien Normand',
      BASSET_BLEU_DE_GASCOGNE: 'Basset Bleu de Gascogne',
      BASSET_FAUVE_DE_BRETAGNE: 'Basset Fauve de Bretagne',
      BASSET_HOUND: 'Basset Hound',
      BAVARIAN_MOUNTAIN_SCENTHOUND: 'Chien rouge de Bavière',
      BEAGLE: 'Beagle',
      BEARDED_COLLIE: 'Colley Barbu',
      BEAUCERON: 'Berger de Beauce',
      BEDLINGTON_TERRIER: 'Bedlington Terrier',
      BELGIAN_GRIFFON: 'Griffon Belge',
      BELGIAN_SHEPHERD_DOG_GROENENDAEL: 'Berger Belge Groenendael',
      BELGIAN_SHEPHERD_DOG_LAEKENOIS: 'Berger Belge Laekenois',
      BELGIAN_SHEPHERD_DOG_MALINOIS: 'Berger Belge Malinois',
      BELGIAN_SHEPHERD_DOG_TERVUREN: 'Berger Belge Tervueren',
      BERGAMASCO_SHEPHERD: 'Berger de Bergame',
      BERNER_NIEDERLAUFHUND: 'Petit Chien Courant Bernois',
      BERNESE_HOUND: 'Chien Courant Bernois',
      BERNESE_MOUNTAIN_DOG: 'Bouvier Bernois',
      BICHON_FRISE: 'Bichon à poil Frisé',
      BILLY_DOG: 'Billy',
      BLACK_AND_TAN_COONHOUND: 'Coonhound noir et feu',
      BLOODHOUND_SAINTHUBERT_DOG: 'Saint Hubert',
      BLUE_PICARDY_SPANIEL: 'Epagneul Bleu Picard',
      BOHEMIAN_WIREHAIRED_POINTING_GRIFFON: 'Griffon d\'arrêt Tchèque',
      BOLOGNESE_DOG: 'Bichon Bolonais',
      BORDEAUX_MASTIFF_FRENCH_MASTIFF: 'Dogue de Bordeaux',
      BORDER_COLLIE: 'Border Collie',
      BORDER_TERRIER: 'Border Terrier',
      BORZOI: 'Barzoï (Lévrier Russe)',
      BOSNIAN_COARSEHAIRED_HOUND: 'Chien Courant de Bosnie',
      BOSTON_TERRIER: 'Terrier de Boston',
      BOURBONNAIS_POINTER: 'Braque du Bourbonnais',
      BOUVIER_DES_FLANDRES: 'Bouvier des Flandres',
      BOXER_DOG: 'Boxer',
      BRAQUE_D_AUVERGNE: 'Braque d\'Auvergne',
      BRAZILIAN_TERRIER: 'Terrier Brésilien',
      BRIARD: 'Berger de Brie',
      BRIQUET_GRIFFON_VENDEEN: 'Briquet Griffon Vendéen',
      BRITTANY_SPANIEL: 'Epagneul Breton',
      BROHOLMER: 'Broholmer',
      BRUNO_JURA_HOUND: 'Petit Chien Courant du Jura',
      BRUNO_JURA_HOUND_BRUNO_TYPE: 'Bruno du Jura type Bruno',
      BRUNO_JURA_HOUND_ST_HUBERT_TYPE: 'Bruno du Jura type Saint Hubert',
      BRUSSELS_GRIFFON: 'Griffon Bruxellois',
      BULLMASTIFF: 'Bullmastiff',
      BULL_TERRIER_ENGLISH_BULL_TERRIER: 'Bull Terrier (English Bull Terrier)',
      BURGOS_POINTER: 'Braque de Burgos',
      CAIRN_TERRIER: 'Cairn Terrier',
      CANAAN_DOG: 'Chien de Canaan',
      CANARY_ISLAND_PODENCO: 'Podenco Canario',
      CANE_CORSO: 'Cane Corso',
      CAO_DE_CASTRO_LABOREIRO: 'Cao de Castro Laboreiro',
      CAO_FILA_DE_SAO_MIGUEL: 'Cao Fila de Sao Miguel',
      CATAHOULA_LEOPARD_DOG: 'Chien Léopard Catahoula',
      CATALAN_SHEEPDOG: 'Berger Catalan',
      CAUCASIAN_SHEPHERD_DOG: 'Berger du Caucase',
      CAVALIER_KING_CHARLES_SPANIEL: 'Cavalier King Charles',
      CA_DE_BOU_PERRO_DE_PRESA: 'Perro de Presa Mallorquin',
      CENTRAL_ASIAN_SHEPHERD_DOG: 'Berger d\'Asie Centrale',
      CESKY_TERRIER: 'Terrier Tchèque',
      CHESAPEAKE_BAY_RETRIEVER: 'Retriever de la baie de Chesapeake',
      CHIHUAHUA: 'Chihuahua',
      CHINESE_CRESTED_DOG: 'Chien Chinois à Crête',
      CHOW_CHOW: 'Chow Chow',
      CIRNECO_DELL_ETNA: 'Cirneco de l\'Etna',
      CLUMBER_SPANIEL: 'Clumber',
      CONTINENTAL_TOY_SPANIEL: 'Epagneul Nain Continental',
      CORSICAN_DOG: 'Chien Corse',
      COTON_DE_TULEAR: 'Coton de Tulear',
      CROATIAN_SHEEPDOG: 'Berger de Croatie',
      CURLYCOATED_RETRIEVER: 'Retriever à poil bouclé',
      CZECHOSLOVAKIAN_WOLFDOG: 'Chien Loup Tchèque',
      DACHSHUND_LONGHAIRED: 'Teckel à poil long',
      DACHSHUND_LONGHAIRED_RABBIT: 'Teckel de Chasse au lapin (poil long)',
      DACHSHUND_SMOOTHHAIRED: 'Teckel à poil ras',
      DACHSHUND_SMOOTHHAIRED_RABBIT: 'Teckel de Chasse au lapin (poils ras)',
      DACHSHUND_WIREHAIRED: 'Teckel à poil dur',
      DACHSHUND_WIREHAIRED_RABBIT: 'Teckel de Chasse au lapin (poil dur)',
      DALMATIAN: 'Dalmatien',
      DANDIE_DINMONT_TERRIER: 'Terrier Dandie Dinmont',
      DOBERMAN_PINSCHER: 'Dobermann',
      DOGO_CANARIO: 'Dogo Canario',
      DOGUE_DE_BORDEAUX: 'Lion d\'Occitanie',
      DRENTSE_PARTRIDGE_DOG: 'Epagneul à perdrix de Drente',
      DREVER: 'Drever',
      DUNKER: 'Dunker',
      DUPUY_POINTER: 'Braque Dupuy',
      DUTCH_SHEPHERD_LONGHAIRED_VARIETY: 'Berger Hollandais à poil long',
      DUTCH_SHEPHERD_ROUGHHAIRED_VARIETY: 'Berger Hollandais à poil dur',
      DUTCH_SHEPHERD_SHORTHAIRED_VARIETY: 'Berger Hollandais à poil court',
      DUTCH_SMOUSHOND: 'Petit Chien Hollandais de Chasse',
      EAST_SIBERIAN_LAIKA: 'Laika de Sibérie Orientale',
      ENGLISH_BULLDOG: 'Bouledogue Anglais',
      ENGLISH_COCKER_SPANIEL: 'Cocker Anglais',
      ENGLISH_POINTER: 'Pointer Anglais',
      ENGLISH_SETTER: 'Setter Anglais',
      ENGLISH_SPRINGER_SPANIEL: 'Springer Spaniel Anglais',
      ENGLISH_TOY_TERRIER: 'Toy Terrier noir et feu',
      ENTLEBUCHER_MOUNTAIN_DOG: 'Bouvier de l\'Entlebuch',
      EURASIER: 'Eurasier',
      FAWN_BRITTANY_BASSET: 'Griffon Fauve de Bretagne',
      FIELD_SPANIEL: 'Field Spaniel',
      FILA_BRASILEIRO: 'Fila Brasileiro',
      FINNISH_HOUND: 'Chien Courant Finnois',
      FINNISH_LAPPHUND: 'Chien Finnois de Laponie',
      FINNISH_SPITZ: 'Spitz Finlandais',
      FLATCOATED_RETRIEVER: 'Retriever à poil plat',
      FOXHOUND_ENGLISH_FOXHOUND: 'Foxhound (Foxhound Anglais)',
      FRENCH_BULLDOG: 'Bouledogue Français',
      FRENCH_SPANIEL: 'Epagneul Français',
      FRENCH_WHITE_AND_BLACK_HOUND: 'Français Blanc et Noir',
      FRENCH_WHITE_AND_ORANGE_HOUND: 'Français Blanc et Orange',
      FRISIAN_WATER_DOG: 'Chien d\'eau Frison',
      GASCONY_POINTER: 'Braque Français type Gascogne',
      GERMAN_LONGHAIRED_POINTER: 'Chien d\'arrêt Allemand à poil long',
      GERMAN_PINSCHER: 'Pinscher Moyen',
      GERMAN_SHEPHERD: 'Berger Allemand',
      GERMAN_SHORTHAIRED_POINTER: 'Braque Allemand à poil court',
      GERMAN_SPITZ: 'Spitz Allemand (Grand)',
      GERMAN_WIREHAIRED_POINTER: 'Braque Allemand à poil dur',
      GIANT_SCHNAUZER: 'Schnauzer géant',
      GLEN_OF_IMAAL_TERRIER: 'Terrier Irlandais Glen of Imaal',
      GOLDEN_RETRIEVER: 'Golden Retriever',
      GORDON_SETTER: 'Setter Gordon',
      GOTH_SHEPHERD_DOG: 'Chien des Goths',
      GRAND_ANGLOFRANCAIS_BLANC_ET_NOIR: 'Grand Anglo Français Blanc et Noir',
      GRAND_ANGLOFRANCAIS_BLANC_ET_ORANGE: 'Grand Anglo Français Blanc et Orange',
      GRAND_ANGLOFRANCAIS_TRICOLORE: 'Grand Anglo Français tricolore',
      GRAND_BASSET_GRIFFON_VENDEEN: 'Grand Basset Griffon Vendéen',
      GRAND_BLEU_DE_GASCOGNE: 'Grand Bleu de Gascogne',
      GRAND_GASCONSAINTONGEOIS_HOUND: 'Grand Gascon Saintongeois',
      GRAND_GRIFFON_VENDEEN: 'Grand Griffon Vendéen',
      GRAND_SPANISH_HOUND: 'Chien Courant Espagnol (grand)',
      GREATER_SWISS_MOUNTAIN_DOG: 'Grand Bouvier Suisse',
      GREAT_DANE: 'Dogue Allemand',
      GREAT_PYRENEES: 'Montagne des Pyrénées',
      GREENLAND_DOG: 'Esquimau du Groënland',
      GREYHOUND: 'Greyhound',
      HALDEN_HOUND: 'Chien Courant de Halden',
      HAMILTONSTOVARE: 'Hamilton Stovare',
      HANOVERIAN_SCENTHOUND: 'Chien rouge de Hanovre',
      HANOVER_HOUND: 'Brachet Allemand à poil court',
      HARRIER: 'Beagle Harrier',
      HAVANESE_DOG: 'Bichon Havanais',
      HELLENIC_HOUND: 'Chien Courant Grec',
      HOKKAIDO: 'Hokkaido',
      HOVAWART: 'Hovawart',
      HUNGARIAN_GREYHOUND: 'Lévrier Hongrois',
      HUNGARIAN_KUVASZ: 'Kuvasz (Berger Hongrois)',
      HYGEN_HOUND: 'Chien Courant de Hygen',
      IBIZAN_HOUND_SHORT_HAIRED: 'Podenco Ibicenco de pelo corto',
      IBIZAN_HOUND_WIRE_HAIRED: 'Podenco Ibicenco de pelo duro',
      ICELANDIC_SHEEPDOG: 'Berger d\'Islande',
      IRISH_RED_AND_WHITE_SETTER: 'Setter Irlandais rouge',
      IRISH_SETTER: 'Setter Irlandais rouge et blanc',
      IRISH_TERRIER: 'Terrier Irlandais',
      IRISH_WATER_SPANIEL: 'Chien d\'eau Irlandais',
      IRISH_WOLFHOUND: 'Lévrier Irlandais',
      ISTRIAN_COARSEHAIRED_HOUND: 'Chien Courant d\'Istrie à poil dur',
      ISTRIAN_SHORTHAIRED_HOUND: 'Chien Courant d\'Istrie à poil ras',
      ITALIAN_GREYHOUND: 'Petit Lévrier Italien',
      ITALIAN_POINTING_DOG: 'Braque Italien',
      ITALIAN_SHORTHAIRED_HOUND: 'Chien Courant Italien à poil court',
      ITALIAN_SPITZ: 'Spitz Italien',
      ITALIAN_WIREHAIRED_HOUND: 'Chien Courant Italien à poil dur',
      JACK_RUSSELL_TERRIER: 'Jack Russell Terrier',
      JAGDTERRIER: 'Jagd Terrier',
      JAPANESE_SPANIEL_CHIN: 'Epagneul Japonais',
      JAPANESE_SPITZ: 'Spitz Japonais',
      JAPANESE_TERRIER: 'Terrier japonais',
      KAI_KEN: 'Kai',
      KARELIAN_BEAR_DOG: 'Chien d\'Ours de Carélie',
      KARST_SHEPHERD: 'Berger de Karst',
      KERRY_BLUE_TERRIER: 'Kerry Blue Terrier',
      KISHU_KEN: 'Kishu',
      KOMONDOR: 'Komondor',
      KOREAN_JINDO_DOG: 'Korea Jindo Dog',
      KROMFOHRLANDER: 'Kromfohrlander',
      KYILEO: 'Kyi Leo',
      LABRADOR: 'Labrador',
      LAKELAND_TERRIER: 'Lakeland Terrier',
      LANDSEER: 'Landseer',
      LAPPONIAN_HERDER: 'Berger Finnois de Laponie',
      LARGE_MUNSTERLANDER: 'Grand Munsterlander',
      LEONBERGER: 'Leonberg (Leos)',
      LHASA_APSO: 'Lhassa Apso',
      LOWCHEN_LITTLE_LION_DOG: 'Petit Chien Lion',
      LUCERNE_HOUND: 'Chien Courant Lucernois',
      LUZERNER_LAUFHUND: 'Petit Chien Courant Lucernois',
      MAJORCA_SHEPHERD_DOG: 'Berger Espagnol de Majorque',
      MALTESE_DOG: 'Bichon Maltais',
      MANCHESTER_TERRIER: 'Terrier de Manchester',
      MAREMMA_SHEEPDOG: 'Berger de Maremme et Abruzzes',
      MASTIFF_FRENCH_MASTIFF: 'Mastiff inscrit LOF',
      MEDIUM_POODLE: 'Caniche (Moyen)',
      MEXICAN_HAIRLESS_DOG: 'Chien du Mexique à peau nue',
      MINIATURE_BULL_TERRIER: 'Bull Terrier Miniature',
      MINIATURE_DACHSHUND_LONGHAIRED: 'Teckel nain à poil long',
      MINIATURE_DACHSHUND_SMOOTHHAIRED: 'Teckel nain à poil ras',
      MINIATURE_DACHSHUND_WIREHAIRED: 'Teckel nain à poil dur',
      MINIATURE_PINSCHER: 'Pinscher Nain',
      MINIATURE_POODLE: 'Caniche (Nain)',
      MINIATURE_SCHNAUZER: 'Schnauzer nain',
      MIXED_BREED_CROSSBREED: 'Croisé',
      MUDI: 'Mudi (Berger Hongrois)',
      NEAPOLITAN_MASTIFF: 'Mâtin de Naples',
      NEWFOUNDLAND: 'Terre Neuve',
      NORFOLK_TERRIER: 'Norfolk Terrier',
      NORRBOTTENSPETS: 'Spitz de Norrbotten',
      NORWEGIAN_BUHUND: 'Buhund Norvégien',
      NORWEGIAN_ELKHOUND_BLACK: 'Chien d\'Elan Norvégien noir',
      NORWEGIAN_ELKHOUND_GRAY: 'Chien d\'Elan Norvégien gris',
      NORWEGIAN_LUNDEHUND: 'Chien Norvégien de Macareux',
      NORWICH_TERRIER: 'Norwich Terrier',
      NOVA_SCOTIA_DUCK_TOLLING_RETRIEVER: 'Retriever de la nouvelle Ecosse',
      OLD_DANISH_POINTER: 'Ancien Chien d\'arrêt Danois',
      OLD_ENGLISH_SHEEPDOG: 'Bobtail',
      OTTERHOUND: 'Chien de Loutre',
      PARSON_RUSSELL_TERRIER: 'Parson Jack Russell Terrier',
      PEKINGESE: 'Pékinois',
      PERUVIAN_HAIRLESS_DOG_LARGE: 'Chien du Pérou à peau nue (grand)',
      PERUVIAN_HAIRLESS_DOG_MEDIUM: 'Chien du Pérou à peau nue (moyen)',
      PERUVIAN_HAIRLESS_DOG_SMALL: 'Chien du Pérou à peau nue (petit)',
      PETIT_BASSET_GRIFFON_VENDEEN: 'Anglo Français de Petite Vénerie',
      PETIT_BRABANCON: 'Petit Brabancon',
      PETIT_GASCON_SAINTONGEOIS: 'Petit Gascon Saintongeois',
      PHARAOH_HOUND: 'Chien du Pharaon',
      PICARDY_SHEPHERD: 'Berger Picard',
      PICARDY_SPANIEL: 'Epagneul Picard',
      POITEVIN: 'Poitevin',
      POLISH_HOUND: 'Brachet Polonais',
      POLISH_LOWLAND_SHEEPDOG: 'Berger Polonais de Plaine',
      PONTAUDEMER_SPANIEL: 'Epagneul Pont Audemer',
      PORCELAINE: 'Porcelaine',
      PORTUGUESE_PODENGO_GRANDE: 'Podengo Portugais Grande',
      PORTUGUESE_PODENGO_MEDIO: 'Podengo Portugais Medio',
      PORTUGUESE_PODENGO_PEQUENO: 'Podengo Portugais Pequeno',
      PORTUGUESE_POINTER: 'Braque Portuguais',
      PORTUGUESE_SHEEPDOG: 'Berger Portugais',
      PORTUGUESE_SHEEPDOG_LONGHAIRED: 'Chien de montagne Portugais à poil ondulé',
      PORTUGUESE_SHEEPDOG_SHORTHAIRED: 'Chien de montagne Portugais à poil court',
      PORTUGUESE_WATER_DOG: 'Chien d\'eau Portugais',
      POSAVAC_HOUND: 'Chien Courant de Posavatz',
      PRAGUE_RATTER: 'Ratier praguois',
      PUDEL_POINTER: 'Pudel Pointer',
      PUG: 'Carlin',
      PULI_HUNGARIAN_SHEPHERD: 'Puli (Berger Hongrois)',
      PUMI_HUNGARIAN_SHEPHERD: 'Pumi (Berger Hongrois)',
      PYRENEAN_MOUNTAIN_DOG: 'Mâtin des Pyrénées',
      PYRENEAN_POINTER: 'Braque Français type Pyrénées',
      PYRENEAN_SHEEPDOG_LONGFACED_VARIETY: 'Berger des Pyrénées à poil long',
      PYRENEAN_SHEEPDOG_SMOOTHFACED_VARIETY: 'Berger des Pyrénées à face rase',
      RAFEIRO_DE_ALENTEJO: 'Rafeiro de Alentejo',
      REDBONE_COONHOUND: 'Redbone Coonhound',
      REDTICK_COONHOUND: 'Redtick Coonhound',
      RHODESIAN_RIDGEBACK: 'Rhodesian Ridgeback',
      ROMAGNA_WATER_DOG: 'Chien d\'eau Romagnol',
      ROTTWEILER: 'Rottweiler',
      ROUGH_COLLIE: 'Colley à poil long',
      RUSSIAN_BLACK_TERRIER: 'Terrier Noir Russe',
      RUSSOEUROPEAN_LAIKA: 'Laika Russo Européen',
      SAARLOOSWOLFHOND: 'Chien Loup de Saarloos',
      SAINTUSUGE_SPANIEL: 'Epagneul de Saint-Usuge',
      SAINT_BERNARD: 'Saint Bernard',
      SALUKI: 'Saluki',
      SAMOYED: 'Samoyède',
      SANSHU: 'Sanshu',
      SCHAPENDOES: 'Schapendoes',
      SCHILLERSTOVARE: 'Schiller Stovare',
      SCHIPPERKE: 'Schipperke',
      SCHWEIZER_LAUFHUND: 'Chien Courant de Schwyz',
      SCOTTISH_DEERHOUND: 'Lévrier Ecossais',
      SCOTTISH_TERRIER: 'Terrier Ecossais',
      SEALYHAM_TERRIER: 'Sealyham Terrier',
      SHAR_PEI: 'Shar Peï',
      SHETLAND_SHEEPDOG: 'Berger des Shetland',
      SHIBA_INU: 'Shiba (Shiba Inu)',
      SHIH_TZU: 'Shih Tzu',
      SHIKOKU: 'Shikoku',
      SHORTHAIRED_HUNGARIAN_POINTER: 'Braque Hongrois à poil court',
      SIBERIAN_HUSKY: 'Husky Sibérien',
      SILKY_TERRIER: 'Silky Terrier (Sydney Silky)',
      SKYE_TERRIER: 'Skye Terrier',
      SLOUGHI: 'Sloughi',
      SLOVAKIAN_WIREHAIRED_POINTER: 'Braque Slovaque à poil dur',
      SLOVAK_CUVAC: 'Berger Slovaque',
      SLOVAK_HOUND: 'Chien Courant Slovaque',
      SMALAND_HOUND: 'Smalandsstovare',
      SMALL_MUNSTERLANDER: 'Petit Munsterlander',
      SMALL_SPANISH_HOUND: 'Chien Courant Espagnol (petit)',
      SMOOTH_COLLIE: 'Colley à poil court',
      SMOOTH_FOX_TERRIER_ENGLISH_FOX_TERRIER: 'Fox Terrier à poil lisse (Fox Anglais)',
      SOFTCOATED_WHEATEN_TERRIER: 'Terrier Irlandais à poil doux',
      SOUTH_RUSSIAN_OVCHARKA: 'Berger de Russie Méridionale',
      SPANISH_GREYHOUND_GALGO_ESPANOL: 'Galgo Espagnol',
      SPANISH_MASTIFF: 'Mâtin Espagnol',
      SPANISH_WATER_DOG: 'Chien d\'eau Espagnol',
      SPINONE_ITALIANO: 'Spinone Italiano',
      STABYHOUN: 'Stabyhoun (Chien d\'arrêt Frison)',
      STAFFORDSHIRE_BULL_TERRIER: 'StaffordShire Bull Terrier LOF',
      STANDARD_POODLE: 'Caniche (Grand)',
      STANDARD_SCHNAUZER: 'Schnauzer moyen',
      STICHELHAAR: 'Stichelhaar',
      STYRIAN_COARSEHAIRED_HOUND: 'Brachet de Styrie à poil dur',
      ST_GERMAIN_POINTING_DOG: 'Braque Saint Germain',
      SUSSEX_SPANIEL: 'Sussex Spaniel',
      SWEDISH_ELKHOUND: 'Chien d\'Elan Suédois',
      SWEDISH_LAPPHUND: 'Chien Suédois de Laponie',
      TATRA_MOUNTAIN_SHEEPDOG: 'Berger Polonais de Podhale',
      TECKEL_DE_CHASSE_AU_LAPIN_POIL_DUR: 'Chien Courant de Transylvanie',
      TIBETAN_MASTIFF: 'Dogue du Tibet',
      TIBETAN_SPANIEL: 'Epagneul du Tibet',
      TIBETAN_TERRIER: 'Terrier du Tibet',
      TOSA: 'Tosa inscrit LOF',
      TOY_POODLE: 'Caniche (Toy) (Caniche miniature)',
      TRICOLOUR_HOUND: 'Français Tricolore',
      TYROLEAN_HOUND: 'Brachet Tyrolien',
      WACHTELHUND: 'Chien d\'Oysel (Wachtelhund)',
      WEIMARANER_LONGHAIRED: 'Braque de Weimar à poil long',
      WEIMARANER_SHORTHAIRED: 'Braque de Weimar à poil court',
      WELSH_CORGI_CARDIGAN: 'Welsh Corgi Cardigan',
      WELSH_CORGI_PEMBROKE: 'Welsh Corgi Pembroke',
      WELSH_SPRINGER_SPANIEL: 'Springer Spaniel Gallois',
      WELSH_TERRIER: 'Welsh Terrier',
      WESTPHALIAN_DACHSBRACKE: 'Basset de Westphalie',
      WEST_HIGHLAND_WHITE_TERRIER: 'West Highland White Terrier',
      WEST_SIBERIAN_LAIKA: 'Laika de Sibérie Occidentale',
      WHIPPET: 'Whippet',
      WHITE_SWISS_SHEPHERD_DOG: 'Berger Blanc Suisse',
      WIREHAIRED_HUNGARIAN_POINTER: 'Braque Hongrois à poil dur',
      WIREHAIRED_POINTING_GRIFFON: 'Griffon à poil Laineux',
      WIRE_FOX_TERRIER: 'Fox Terrier à poil dur',
      YORKSHIRE_TERRIER: 'Yorkshire Terrier',
      YUGOSLAVIAN_MOUNTAIN_HOUND: 'Chien Courant Yougoslave de Montagne',
      YUGOSLAVIAN_SHEPHERD_DOG: 'Berger Yougoslave',
      YUGOSLAVIAN_TRICOLOUR_HOUND: 'Chien Courant Yougoslave Tricolore'
    }
  },
  cancellation: {
    no_use_transfer_cta_primary: 'J\'offre mon traceur',
    no_use_transfer_cta_secondary: 'Résilier quand même',
    no_use_transfer_info: 'Votre proche doit d\'abord créer un compte Weenect. C\'est gratuit, sans abonnement ni achat de traceur. Prévenez-le pour accélérer le transfert.',
    no_use_transfer_subtitle: 'Un autre animal pourrait en profiter ! Offrez-le à un proche : il bénéficiera d\'un mois d\'abonnement offert. De votre côté, votre abonnement sera résilié et vous ne serez plus prélevé.',
    no_use_transfer_title: 'Et si vous offriez votre traceur à un proche ?'
  },
  changePaymentMean: {
    ADD_BANK_ACCOUNT: 'Ajouter un compte à débiter',
    ADD_BANK_CARD: 'Passer au paiement par carte bancaire',
    BANK_ACCOUNT_ERROR: 'Une erreur est survenue lors du changement de vos informations bancaires. Veuillez contacter le service client.',
    BANK_ACCOUNT_EXPLANATION: 'Sachez qu\'aucune de vos informations bancaires ne sont enregistrées par nos serveurs.',
    BANK_ACCOUNT_SUCCESS: 'Informations bancaires mises à jour',
    BANK_CARD_ERRORED: 'Une erreur est survenue lors de la mise à jour de votre moyen de paiement. Veuillez contacter le <1>service client</1>.',
    BANK_CARD_UPDATED: 'Carte bancaire mise à jour',
    CAPTATION: 'Afin de mettre à jour vos coordonnées bancaires, nous allons procéder à une prise d\'autorisation de {{ amount }} sur votre carte.',
    CAPTATION_EXPLANATION1: 'Ce montant ne sera pas prélevé. La transaction est immédiatement annulée.',
    CAPTATION_EXPLANATION2: 'Cette procédure nous permet de respecter les standards de paiement sur Internet et de garantir la sécurité de vos coordonnées bancaires. Aucune de ces informations ne transitera par nos serveurs.',
    CAPTATION_EXPLANATION3: 'IMPORTANT : le formulaire de prélèvement portera le nom "Hareau" et non "Weenect". C\'est normal, il s\'agit du nom de notre entreprise. "Weenect" étant le nom commercial.',
    CAPTATION_EXPLANATION4: 'Changez le compte bancaire à prélever tout en gardant le même abonnement.',
    CARD_AUTHORIZED: 'Moyens de paiement autorisés :',
    CHANGE_PAYMENT_MEAN: 'Mettre à jour ma carte bancaire',
    CURRENT_CHOICE_CB: 'Vous avez choisi de payer par carte bancaire.',
    CURRENT_CHOICE_IBAN: 'Vous avez choisi de payer par IBAN',
    CURRENT_MEAN: 'Mode de paiement actuel',
    CURRENT_MEAN_PHRASE: 'Vous avez choisi de payer par carte bancaire',
    CURRENT_MEAN_PHRASE_GOCARDLESS: 'Vous avez choisi de payer par prélèvement bancaire ',
    DEFAULT_MEAN: 'Moyen de paiement par défaut :',
    GO_TO_SEPA: 'Passer au prélèvement bancaire',
    MODIFY: 'Modifier mon moyen de paiement',
    TITLE: 'Moyen de paiement',
    UPDATE_BANK_ACCOUNT: 'Mettre à jour mon IBAN',
    UPDATE_BANK_CARD: 'Mettre à jour ma carte bancaire',
    USED_PAYMENT_EXPLANATION: 'Ce mode de paiement est utilisé pour payer vos abonnements et vos options.'
  },
  change_password: {
    warning_logout_all: 'Pour votre sécurité, changer votre mot de passe vous déconnectera de tous vos appareils. Vous devrez vous reconnecter avec le nouveau mot de passe.'
  },
  commonActions: {
    ACTIVATE: 'Activer',
    BACK: 'Retour',
    CANCEL: 'Annuler',
    CAN_BE_CANCELED: 'L\'annulation est possible à tout moment.',
    CHANGE: 'Enregistrer',
    CONFIGURE: 'Configurer',
    DEACTIVATE: 'Désactiver',
    GO_MAP: 'Aller à la carte',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Un problème est survenu'
    },
    NEXT: 'Suivant',
    NO: 'Non',
    OK: 'Ok',
    REGISTER: 'Activer',
    SAVE: 'Enregistrer',
    SELECT_ALL: 'Tout sélectionner',
    SEND: 'Envoyer',
    SUBSCRIBE: 'Je souscris',
    THEN: 'puis ',
    UNSELECT_ALL: 'Tout désélectionner',
    UPDATE: 'Enregistrer',
    VALIDATE: 'Valider',
    YES: 'Oui'
  },
  creditCardAlert: {
    AUTO_RENEWAL_ADVICE: 'Si vous souhaitez continuer à utiliser votre traceur, veuillez ajouter un nouveau moyen de paiement dès maintenant.',
    AUTO_RENEWAL_NOTICE: 'Attention ! Votre abonnement arrive bientôt à échéance et votre carte bancaire a expiré.'
  },
  emailPreferences: {
    EMAIL_LISTS: {
      COMPANY_NEWS: 'Actualités de l\'entreprise',
      NEW_FEATURES: 'Nouvelles fonctionnalités',
      OFFERS: 'Offres promotionnelles',
      SERVICE_STATUS: 'Pannes de service et mises à jour',
      SURVEYS_AND_TESTS: 'Enquêtes et Beta tests',
      TUTORIALS: 'Tutoriels'
    },
    EMAIL_LISTS_HEADER: 'Liste des emails',
    EMAIL_LISTS_INFO: {
      SERVICE_STATUS: 'Nécessaire au bon fonctionnement du service.'
    },
    ENGAGEMENT_NOTIFICATIONS_CHECKBOX: 'Je souhaite recevoir les notifications d\'aide à l\'utilisation de l\'application mobile',
    ENGAGEMENT_NOTIFICATIONS_DESCRIPTION: 'Ces notifications vous permettront de mieux prendre en main l\'application mobile en vous proposant des conseils d\'utilisation.',
    ENGAGEMENT_NOTIFICATIONS_TITLE: 'Conseils d\'utilisation',
    LANGUAGE_PREFERENCES_DESCRIPTION: 'Choisissez la langue dans laquelle vous souhaitez recevoir les e-mails :',
    OPEN_TRACKING_CHECKBOX_TEXT: 'J\'accepte le suivi de l\'ouverture de mes e-mails',
    OPEN_TRACKING_DESCRIPTION: 'Le suivi des ouvertures nous aide à mesurer l\'efficacité de nos communications et à adapter la fréquence ainsi que le contenu de nos e-mails.',
    OPEN_TRACKING_HEADLINE: 'Suivi de l\'ouverture des e-mails',
    PREFERENCES_DECRIPTION: 'Choisissez le type de mails que vous souhaitez recevoir. Nous vous enverrons uniquement ceux correspondant à vos choix. '
  },
  error: {
    TITLE: 'Oups un problème est survenu '
  },
  errors: {
    DEFAULT: 'Champ invalide',
    FIELD_REQUIRED: 'Ce champ est requis',
    GENERAL: 'Une erreur est survenue, veuillez réessayer',
    IMEI: 'Renseignez un numéro IMEI valide',
    MAIL_FORMAT: 'Ce format d\'email est invalide',
    MAX_LENGTH: 'Le champ peut contenir 15 caractères maximum',
    PASSWORD_FORMAT: 'Votre mot de passe doit avoir au minimum un chiffre, une majuscule et une minuscule.',
    PHONE_FORMAT: 'Le numéro de téléphone doit inclure le préfixe international',
    PROMO_CODE: 'Code promo non valable'
  },
  forgotPassword: {
    FORGOT_PASSWORD_BUTTON: 'Recevoir un lien mot de passe oublié',
    FORGOT_PASSWORD_CANCEL: 'Retour à la connexion',
    FORGOT_PASSWORD_ERRORS: {
      UNKNOWN: 'Une erreur est survenue. Merci de contacter notre service d\'aide.'
    },
    FORGOT_PASSWORD_EXPIRED: 'Le lien de réinitialisation de mot de passe a expiré.',
    FORGOT_PASSWORD_RETRY: 'Demander un nouveau lien mot de passe oublié',
    FORGOT_PASSWORD_SUCCESS: 'S\'il y a un compte associé à l\'adresse {{mail}}, vous recevrez un email avec un lien pour réinitialiser votre mot de passe.'
  },
  forgotpassword: {
    BACK_TO_LOGIN_CTA: 'Retour à la connexion',
    CONFIRMATION_SUBTITLE: 'S\'il y a un compte associé à l\'adresse {{email}}, vous recevrez un email avec un lien pour réinitialiser votre mot de passe.',
    CONFIRMATION_TITLE: 'Email envoyé !',
    EMAIL_CONFIRM_PLACEHOLDER: 'Confirmer l\'adresse e-mail',
    EMAIL_PLACEHOLDER: 'Adresse e-mail',
    SUBMIT_CTA: 'Recevoir un lien mot de passe oublié',
    SUBTITLE: 'Entrez votre adresse email pour recevoir un lien de réinitialisation.',
    TITLE: 'Mot de passe oublié ?'
  },
  forms: {
    CITY: {
      LABEL: 'Ville',
      PLACEHOLDER: 'Votre ville'
    },
    CONFIRM_PASSWORD: {
      LABEL: 'Confirmation mot de passe',
      PLACEHOLDER: 'Confirmer'
    },
    COUNTRY: {
      LABEL: 'Pays'
    },
    EMAIL: {
      LABEL: 'Adresse email',
      PLACEHOLDER: 'votre@email.com'
    },
    FIRST_NAME: {
      LABEL: 'Prénom',
      PLACEHOLDER: 'Votre prénom'
    },
    LANGUAGE: {
      LABEL: 'Langue'
    },
    LAST_NAME: {
      LABEL: 'Nom',
      PLACEHOLDER: 'Votre nom'
    },
    NEW_PASSWORD: {
      LABEL: 'Nouveau mot de passe',
      PLACEHOLDER: 'Votre nouveau mot de passe'
    },
    OLD_PASSWORD: {
      LABEL: 'Ancien mot de passe',
      PLACEHOLDER: 'Votre ancien mot de passe'
    },
    PASSWORD: {
      LABEL: 'Mot de passe',
      PLACEHOLDER: 'Mot de passe',
      VALIDATION: 'Votre mot de passe doit faire au moins 8 caractères.',
      WARNING: 'Attention, "azertyuiop" et "123456789" ne sont PAS des mots de passe forts.\nTestez la sécurité de votre mot de passe ici : <1>https://howsecureismypassword.net</1>'
    },
    PHONE: {
      LABEL: 'Téléphone',
      PLACEHOLDER: '+33600000000'
    },
    POSTAL_CODE: {
      LABEL: 'Code postal',
      PLACEHOLDER: 'Votre code postal',
      STREET_NUMBER: 'N° et voie'
    },
    STREET: {
      LABEL: 'Adresse',
      PLACEHOLDER: 'Numéro et nom de rue'
    }
  },
  general: {
    ALERT_ZONES: 'Zones d\'alertes',
    BACK_BUTTON: 'Retour',
    DISABLED: 'Désactivé',
    EMAIL: 'E-mail',
    ENABLED: 'Activé',
    ENERGY_SAVING_ZONES: 'Zones d\'économie d\'énergie',
    ERROR_FORMAT: 'Désolé, ce format n’est pas valide',
    ERROR_MISMATCH: 'Les deux champs doivent être identiques',
    ERROR_NETWORK: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
    ERROR_PAGE_TITLE: 'Oups, un problème est survenu.',
    FROM: 'De',
    HISTORY: 'Historique',
    LOGOUT_MENU_DISCONNECT: 'Déconnexion',
    MOBILE_ONLY_SETTINGS_NOTE: 'Vous pouvez modifier ces paramètres à tout moment dans l\'application mobile Weenect.',
    NONE: 'Aucun',
    NOTIFICATIONS: 'Notifications',
    OPEN: 'Ouvrir',
    PUSH: 'Push',
    SAFETY_ZONES: 'Zones de sécurité',
    SMS: 'SMS',
    TO: 'à',
    TRACKER_PROFILE: 'Profil du traceur',
    password_length: 'Votre mot de passe doit faire au minimum 8 caractères.',
    save_button: 'Enregistrer'
  },
  general_password_length: 'Votre mot de passe doit faire au minimum 8 caractères.',
  geofences: {
    CREATE: {
      HEADLINE: 'Créer une zone'
    },
    EDIT: {
      DELETE_GEOFENCE: 'Supprimer la zone',
      ENTRANCE_NOTIFICATION: 'Notification d\'entrée',
      EXIT_NOTIFICATION: 'Notification de sortie',
      GEOCODE_LABEL: 'Utiliser une adresse',
      GEOCODE_PLACEHOLDER: 'Tapez l\'adresse ici',
      LOCATION: 'Position du centre de la zone',
      NAME_INPUT: {
        LABEL: 'Nom de la zone',
        PLACRHOLDER: 'Renseignez le nom de la zone'
      },
      OUTDOORS: 'Zone extérieure (parc, forêt)',
      OUTDOORS_TOOLTIP: 'Le GPS étant plus précis en extérieur, les règles pour le déclenchement d\'une notification d\'entrée ou de sortie sont différentes entre une zone intérieure et une zone extérieure.',
      POINT_ON_THE_MAP_TEXT: 'ou cliquez directement sur la carte',
      RADIUS: 'Taille de la zone (rayon en mètre)',
      TRACKER_LAST_POSITION_BUTTON: 'Utiliser le position du traceur',
      UNKNOWN_ADDRESS: 'Adresse inconnue'
    }
  },
  header: {
    ALL_TRACKERS: 'Tous les traceurs',
    AVAILABLE_PLURAL: 'disponible(s)',
    NAV: {
      ACCOUNT: 'Compte',
      INSURANCE: 'Assurance',
      LOGOUT: 'Déconnexion',
      SUPPORT: 'Assistance',
      TRACKERS: 'Carte'
    },
    SEARCHBAR_RESULT: 'traceurs trouvés',
    SEARCHBAR_TITLE: 'Rechercher un traceur :',
    TRACKERS: 'traceur(s)',
    WHITE_LABEL: {
      IN_PARTERNSHIP_WITH: 'En partenariat avec'
    }
  },
  history: {
    DATE_SELECTOR_LABEL: 'Choisir un jour à afficher',
    MARKER_END: 'Fin',
    MARKER_START: 'Début',
    PLAYBACK_BUTTON: 'Pause',
    PLAYBACK_POSITION: 'Position {{index}} / {{total}}',
    PLAYBACK_TIME_LABEL: 'Durée',
    PLAY_CTA: 'Lancer',
    POINT_BATTERY_LABEL: 'Batterie :',
    POINT_POSITION_LABEL: 'Position :',
    POINT_TIME_LABEL: 'Heure :',
    RANGE_SLIDER_LABEL: 'Utilisez le curseur pour sélectionner la période à afficher :',
    STATS_DISTANCE_LABEL: 'Distance totale',
    STATS_DURATION_LABEL: 'Durée',
    STATS_SPEED_AVG_LABEL: 'Vitesse moy.',
    STATS_SPEED_MAX_LABEL: 'Vitesse max.',
    STATS_TITLE: 'Détail de l\'activité',
    STOP_CTA: 'STOP',
    TIMEFRAME_12H: '12 h',
    TIMEFRAME_1H: '1 h',
    TIMEFRAME_24H: '24 h',
    TIMEFRAME_3H: '3 h',
    TIMEFRAME_6H: '6 h',
    TIMEFRAME_LABEL: 'Montrer les dernières'
  },
  home: {
    ACCOUNT_CARD_TITLE: 'Mon compte',
    ADD_TRACKER_CTA: 'Ajouter un traceur',
    AI_ASSISTANT_ITEM: 'Assistant IA',
    ALERT_ZONES_ITEM: 'Zones d\'alertes',
    CONTACT_FORM_ITEM: 'Formulaire de contact',
    ENERGY_ZONES_ITEM: 'Zones d\'économie d\'énergie',
    GREETING: 'Bonjour {{firstname}}',
    HELP_CARD_TITLE: 'Besoin d\'aide ?',
    HELP_CENTER_ITEM: 'Centre d\'aide',
    HISTORY_CARD_TITLE: 'Historique',
    MANAGE_SUBSCRIPTION_CTA: 'Gérer mon abonnement',
    MAP_CARD_TITLE: 'Carte',
    NOTIFICATIONS_ITEM: 'Notifications',
    PASSWORD_ITEM: 'Mot de passe',
    PAYMENT_METHOD_CTA: 'Moyen de paiement et factures',
    PREFERENCES_ITEM: 'Préférences',
    SUBSCRIPTION_BANNER_LABEL: 'ABONNEMENT DU TRACEUR {{name}}',
    SUBSCRIPTION_LABEL: 'Abonnement {{duration}}',
    SUBSCRIPTION_LABEL_NO_SUBSCRIPTION: 'Pas d\'abonnement',
    SUB_GREETING: 'Bienvenue sur votre espace Weenect',
    TRACKER_PROFILE_ITEM: 'Profil du traceur',
    TRACKER_SELECTOR_LABEL: 'Mes traceurs',
    TRACKER_SETTINGS_CARD_TITLE: 'Paramètres traceur',
    USER_PROFILE_ITEM: 'Profil utilisateur'
  },
  imeiInfo: {
    HINT: 'Vous trouverez le numéro IMEI au dos de votre traceur.',
    IMAGE_ALT: 'Photo du traceur',
    TITLE: 'Numéro IMEI'
  },
  login: {
    EMAIL_PLACEHOLDER: 'Adresse e-mail',
    ERROR_INVALID_CREDENTIALS: 'Mot de passe invalide.',
    FORGOT_PASSWORD: 'Mot de passe oublié ?',
    FORGOT_PASSWORD_LINK: 'Mot de passe oublié ?',
    LOGIN_ERRORS: {
      UNKNOWN: 'La connexion a échoué'
    },
    PASSWORD_PLACEHOLDER: 'Mot de passe',
    REGISTER_CTA: 'Créer un compte gratuitement',
    REGISTER_PROMPT_TITLE: 'Pas encore de compte ?',
    SIGN_IN_BUTTON: 'Connexion',
    SIGN_IN_HEADLINE: 'Connexion',
    SIGN_UP_BUTTON: 'Créer un compte',
    SIGN_UP_HEADLINE: 'Vous n\'avez pas encore de compte ?',
    SUBMIT_CTA: 'Connexion',
    TERMS_LINK: 'Conditions d\'utilisation',
    TERMS_LINK_URL: 'https://www.weenect.com/common/pdf/fr/cgv-weenect.pdf',
    TITLE: 'Connexion'
  },
  manageSubscription: {
    CANCEL: {
      DESCRIBE_YOUR_PROBLEMS: 'Pouvez-vous préciser la raison de votre désabonnement ?',
      GIVE_US_DETAILS: 'Raison de votre désabonnement.',
      REASONS: {
        AFTER_SALES_SERVICE: 'Mauvaise expérience avec le Service client',
        BATTERY: 'Autonomie de la batterie insuffisante',
        LOST_BROKEN: 'Je l\'ai perdu / cassé',
        MOBILE_APPLICATION: 'L’application ne fonctionne pas',
        NOT_SATISFIED: 'Je ne suis pas satisfait de Weenect',
        NO_USE: 'Je n\'en ai plus l\'utilité',
        TOO_EXPENSIVE: 'Je trouve l\'abonnement trop cher',
        TRACKER_FORMAT: 'Format du traceur à revoir (taille et poids)',
        WILL_REACTIVATE_LATER: 'Je réactiverai l\'abonnement plus tard'
      },
      SAD_TO_SEE_YOU_LEAVE: 'Nous sommes tristes de vous voir partir.',
      WHY_DO_YOU_RESIGN: 'Pour quelle raison souhaitez-vous annuler votre abonnement ?'
    },
    CANCEL_EXPIRE: 'Le renouvellement automatique a été annulé. L\'abonnement expirera le {{date}}.',
    CANCEL_QUESTION: 'Vous ne souhaitez pas poursuivre l\'abonnement ?',
    CANCEL_RENEWAL: 'Annuler le renouvellement automatique',
    CANCEL_RENEWAL_BIS: 'Résilier l\'abonnement',
    CANT_RESIGN_UNDER_EXTENDED_NOTICE: 'Vous souhaitez vous désabonner ou simplement désactiver le renouvellement automatique de votre abonnement ?\nAppelez-nous au 01 87 66 98 71 de 9h30 à 16h du lundi au vendredi.',
    CANT_RESIGN_UNDER_NOTICE: 'Vous ne pouvez pas résilier votre abonnement pendant les 30 derniers jours. Veuillez contacter le service client.',
    CANT_RESIGN_UNTIL: 'La résiliation de votre abonnement prendra effet à la fin de votre engagement, soit le {{date}}.',
    CANT_RESIGN_WHILE_COMMITED: 'Vous êtes engagés sur 3 mois, la résiliation de votre abonnement ne prendra effet qu\'à la fin de la période en cours, soit le {{date}}',
    CURRENT_PLAN: 'Abonnement actuel',
    HEADLINE: 'Gérer l\'abonnement',
    MESSAGES: {
      UPDATE_SUCCESS: 'Abonnement mis à jour avec succès.'
    },
    RENEW_SUBSCRIPTION: 'Renouveler l\'abonnement',
    RESIGN_DATE: 'La résiliation de votre abonnement prendra effet à la fin de la période en cours, soit le {{date}}',
    RESUMPTION_DATE: 'Choisir une date de reprise',
    RETURN_TO_TRACKERS: 'Retour à la carte'
  },
  map: {
    ERROR_BANNER_MESSAGE: 'Une erreur est survenue. Veuillez réessayer.',
    FLASHLIGHT_DURATION_10_MIN: '10 min',
    FLASHLIGHT_DURATION_1_MIN: '1 min',
    FLASHLIGHT_DURATION_2_MIN: '2 min',
    FLASHLIGHT_DURATION_30_MIN: '30 min',
    FLASHLIGHT_DURATION_5_MIN: '5 min',
    FLASHLIGHT_MODE_FLASHING: 'Clignotant',
    FLASHLIGHT_MODE_STEADY: 'Continu',
    FLASHLIGHT_TITLE: 'Lampe torche',
    GPS_IN_WIFI_ZONE: 'Dans une zone Wi-Fi',
    IMMOBILE_FOR_DAY: 'Immobile depuis 1 jour',
    IMMOBILE_FOR_DAYS: 'Immobile depuis {{time}} jours',
    IMMOBILE_FOR_HOUR: 'Immobile depuis 1 heure',
    IMMOBILE_FOR_HOURS: 'Immobile depuis {{time}} heures',
    IMMOBILE_FOR_MINUTE: 'Immobile depuis 1 minute',
    IMMOBILE_FOR_MINUTES: 'Immobile depuis {{time}} minutes',
    IMMOBILE_SINCE: 'Immobile depuis {{date}}',
    LAST_COMMUNICATION_AGO: 'Dernière communication il y a {{time}}',
    LAST_COMMUNICATION_ON: 'Dernière communication le {{date}}',
    MAP_SELECTOR_MAP: 'Plan',
    MAP_SELECTOR_MAP_3D: 'Plan 3D',
    MAP_SELECTOR_MAP_HD: 'Plan HD',
    MAP_SELECTOR_PREMIUM_MAPS_TITLE: 'Cartes Premium',
    MAP_SELECTOR_SATELLITE: 'Satellite',
    MAP_SELECTOR_SATELLITE_3D: 'Satellite 3D',
    MAP_SELECTOR_SATELLITE_HD: 'Satellite HD',
    MAP_SELECTOR_STANDARD_MAPS_TITLE: 'Cartes standard',
    MAP_SELECTOR_TERRAIN: 'Relief',
    MAP_SELECTOR_TRAILS: 'Chemins et sentiers',
    NO_GPS_MARKER_TITLE: 'GPS invalide',
    NO_POSITION: 'Pas de position connue',
    ON_DATE: 'le {{date}}',
    POSITION: 'Position',
    POSITION_RECEIVED_DAYS_AGO: 'Position reçue il y a {{time}} jours',
    POSITION_RECEIVED_DAY_AGO: 'Position reçue il y a 1 jour',
    POSITION_RECEIVED_HOURS_AGO: 'Position reçue il y a {{time}} heures',
    POSITION_RECEIVED_HOUR_AGO: 'Position reçue il y a 1 heure',
    POSITION_RECEIVED_MINUTES_AGO: 'Position reçue il y a {{time}} minutes',
    POSITION_RECEIVED_MINUTE_AGO: 'Position reçue il y a 1 minute',
    POSITION_RECEIVED_ON: 'Position reçue le {{date}}',
    POSITION_RECEIVED_SECONDS_AGO: 'Position reçue il y a {{time}} secondes',
    POSITION_RECEIVED_SECOND_AGO: 'Position reçue il y a {{time}} seconde',
    REFRESH_FAILED: 'La mise à jour de la position a échoué.',
    REFRESH_MULTI_TRACKER_SENT: 'Demandes de mise à jour des positions envoyées.',
    REFRESH_SINGLE_TRACKER_SENT: 'Demande de mise à jour de la position envoyée.',
    REFRESH_SUCCEEDED: 'La position a été mise à jour.',
    RING_DURATION_10_SECONDS: '10 s',
    RING_DURATION_1_SECOND: '1 s',
    RING_DURATION_30_SECONDS: '30 s',
    RING_DURATION_3_SECONDS: '3 s',
    RING_DURATION_5_SECONDS: '5 s',
    RING_TITLE: 'Sonnerie',
    STATUS_GOOD: 'Bon',
    STATUS_LOW: 'Faible',
    STATUS_MEDIUM: 'Moyen',
    SUPERLIVE_DURATION_10_MIN: '10 min',
    SUPERLIVE_DURATION_1_MIN: '1 min',
    SUPERLIVE_DURATION_2_MIN: '2 min',
    SUPERLIVE_DURATION_30_MIN: '30 min',
    SUPERLIVE_DURATION_5_MIN: '5 min',
    SUPERLIVE_INFO: 'Bon à savoir : La position réelle du traceur mettra quelques secondes à s’actualiser après le déclenchement du superlive.',
    SUPERLIVE_STOP: 'STOP',
    SUPERLIVE_TIMER_LABEL: 'Temps',
    SUPERLIVE_TITLE: 'Superlive',
    TIME_AGO_DAY: 'il y a 1 jour',
    TIME_AGO_DAYS: 'il y a {{time}} jours',
    TIME_AGO_HOUR: 'il y a 1 heure',
    TIME_AGO_HOURS: 'il y a {{time}} heures',
    TIME_AGO_MINUTE: 'il y a 1 minute',
    TIME_AGO_MINUTES: 'il y a {{time}} minutes',
    TIME_AGO_SECOND: 'il y a {{time}} seconde',
    TIME_AGO_SECONDS: 'il y a {{time}} secondes',
    TRACKER_MODE_ACTIVE_GPS_REPORT: 'Remontée GPS : 30 s',
    TRACKER_MODE_ACTIVE_LABEL: 'Active',
    TRACKER_MODE_ACTIVE_PLUS_GPS_REPORT: 'Remontée GPS : 10 s',
    TRACKER_MODE_ACTIVE_PLUS_LABEL: 'Active Plus',
    TRACKER_MODE_ECO_GPS_REPORT: 'Remontée GPS : 5 min',
    TRACKER_MODE_ECO_LABEL: 'Eco',
    TRACKER_MODE_ECO_PLUS_GPS_REPORT: 'Remontée GPS : désactivée',
    TRACKER_MODE_ECO_PLUS_LABEL: 'Eco Plus',
    TRACKER_MODE_EDIT_ON_MOBILE_NOTICE: 'La modification du mode du traceur se fait directement depuis l’application mobile Weenect.',
    TRACKER_MODE_SMART_GPS_REPORT: 'Remontée GPS : 1 min',
    TRACKER_MODE_SMART_LABEL: 'Smart',
    TRACKER_MODE_TITLE: 'Mode du traceur',
    TRACKER_SIDEBAR_AVAILABLE_TRACKERS_COUNT: '{{number}} traceurs disponibles',
    TRACKER_SIDEBAR_BATTERY_LABEL: 'Batterie',
    TRACKER_SIDEBAR_GPS_SIGNAL_LABEL: 'Signal GPS',
    TRACKER_SIDEBAR_LAST_COMMUNICATION_LABEL: 'Dernière communication',
    TRACKER_SIDEBAR_MULTI_TRACKER_VIEW: 'Vue multi-traceurs',
    TRACKER_SIDEBAR_NETWORK_LABEL: 'Réseau',
    TRACKER_SIDEBAR_NO_KNOWN_POSITION: 'Aucune position connue',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_CTA: 'Souscrire à un abonnement',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_STATE: 'Pas d\'abonnement actif',
    TRACKER_SIDEBAR_NO_SUBSCRIPTION_TITLE: 'Vous n’avez pas d’abonnement actif pour ce traceur',
    TRACKER_SIDEBAR_OTHER_TRACKERS_TITLE: 'Autres traceurs',
    TRACKER_SIDEBAR_POWER_UP_NEXT: 'Suivant',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_BODY: 'Le traceur doit être en extérieur ou près d\'une fenêtre pendant la phase de mise en route.',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_BUTTON: 'J’ai allumé mon traceur',
    TRACKER_SIDEBAR_POWER_UP_STEP_A_TITLE: 'Appuyez 3 secondes sur le bouton central pour allumer votre traceur.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_BODY: 'La première connexion peut prendre jusqu\'à 5 minutes. Vous n\'avez rien à faire de votre côté.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_HINT: 'Patientez jusqu\'à ce que la LED verte se fixe puis s\'éteigne.',
    TRACKER_SIDEBAR_POWER_UP_STEP_B_TITLE: 'Votre traceur cherche maintenant à se connecter au réseau.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_BODY: 'Positionnez le traceur en extérieur, face avant vers le ciel, pour faciliter la recherche de positions GPS.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_HINT: 'Patientez, le traceur recherche sa position.',
    TRACKER_SIDEBAR_POWER_UP_STEP_C_TITLE: 'Maintenant qu\'il est connecté, votre traceur cherche à capter les signaux GPS.',
    TRACKER_SIDEBAR_TITLE: 'Mes traceurs',
    TRACKER_SIDEBAR_TRACKER_STATE_LABEL: 'État du traceur',
    TRACKER_STATE_AIRPLANE_MODE: 'En mode avion',
    TRACKER_STATE_BATTERY_EMPTY: 'Plus de batterie',
    TRACKER_STATE_CONNECTED: 'Traceur connecté',
    TRACKER_STATE_DISCONNECTED: 'Traceur déconnecté',
    TRACKER_STATE_GSM_UNREACHABLE: 'Hors réseau GSM',
    TRACKER_STATE_MANUALLY_OFF: 'Éteint manuellement',
    TRACKER_STATE_POWER_SAVING_AREA: 'En zone d’économie d’énergie',
    TRACKER_STATE_SUBSCRIPTION_EXPIRED: 'Vous n’avez pas d’abonnement',
    VIBRATION_DURATION_10_SECONDS: '10 s',
    VIBRATION_DURATION_1_SECOND: '1 s',
    VIBRATION_DURATION_30_SECONDS: '30 s',
    VIBRATION_DURATION_3_SECONDS: '3 s',
    VIBRATION_DURATION_5_SECONDS: '5 s',
    VIBRATION_RING_INFO: 'Bon à savoir : Éduquez votre animal au rappel, en associant la sonnerie ou le vibreur à son repas.',
    VIBRATION_TITLE: 'Vibration'
  },
  mapControls: {
    MAP_TYPE: 'Type de carte',
    REFRESH_POSITION: 'Rafraîchir la position',
    SUPER_LIVE: 'Superlive',
    ZOOM_IN: 'Zoom +',
    ZOOM_OUT: 'Zoom -'
  },
  mapLayers: {
    CLASSIC_MAPS: 'Cartes standard ',
    DONT_SUBSCRIBE: 'Continuer avec les cartes standard',
    FOREST_PATH: 'Chemins et sentiers',
    GOOGLE_STREET: 'Google Map',
    GRAY: 'Noir et blanc',
    PLAN: 'Plan',
    PREMIUM_MAPS: 'Cartes premium',
    PREMIUM_SUBSCRIBE: 'Souscrire à l’option Cartes Premium',
    PREMIUM_WARNING_MSG: '<1>Oups, vous n’avez pas souscrit à l’option cartes Premium pour le moment !</1>\n\nCette option vous permettra de bénéficier de cartes plus complètes et mises à jour régulièrement afin de mieux observer les déplacements de votre traceur.<br />Les versions Satellite HD, Carte des reliefs, ou encore Chemins de forêt vous permettront de repérer votre traceur en un coup d’oeil.\n\nSouscrivez à cette option pour seulement {{mapOptionPrice}} /mois !',
    RELIEF: 'Relief',
    SATELLITE: 'Satellite',
    STREET: 'Classique',
    UNLOCK_MAPS: 'Débloquez les cartes additionnelles en cliquant dessus !'
  },
  misc: {
    LANGUAGE: {
      DE: 'Allemand',
      EN: 'Anglais',
      ES: 'Espagnol',
      FR: 'Français',
      IT: 'Italien',
      NL: 'Néerlandais'
    },
    NO_DATE: 'Aucune position connue',
    ROTATE_DEVICE: 'Weenect a été conçu pour être utilisé en mode portrait. Veuillez pivoter votre appareil pour profiter au mieux de nos services.',
    locale: 'fr-FR'
  },
  newpassword: {
    EXPIRED_LINK_LINK: 'Demander un nouveau lien mot de passe oublié ',
    EXPIRED_LINK_TEXT: 'Ce lien est expiré. Merci de faire une nouvelle demande de réinitialisation de mot de passe.',
    NEWPASSWORD_CONFIRMATION_PLACEHOLDER: 'Confirmation du mot de passe',
    NEWPASSWORD_PLACEHOLDER: 'Nouveau mot de passe',
    SCREEN_TITLE: 'Nouveau mot de passe'
  },
  onboarding: {
    ACTIVATING_HINT: 'Durée moyenne d\'activation de 5 minutes',
    ACTIVATING_INDICATOR: 'En cours d\'activation',
    GREET: {
      BUTTON: 'Mon traceur est allumé',
      COMMON_TEXT: 'Pour bien commencer nous vous recommandons de suivre le tutoriel suivant. Il vous aidera dans la prise en main de votre traceur.\n\nDébutons avec la mise en route de votre traceur. Suivez les indications ci-dessous afin de l\'allumer :',
      MAIN_TITLE: 'Informations de contact',
      RED_TEXT: 'Il faut que le traceur soit en extérieur pour qu\'il puisse obtenir une position GPS'
    },
    MAP_INTERACTIONS: {
      COMMON_TEXT: {
        PET: 'De haut en bas ces boutons vous permettent de faire sonner ou vibrer votre traceur. Ces fonctionnalités vous permettent d\'éduquer votre animal au rappel.',
        SILVER: 'De haut en bas ces boutons vous permettent de faire sonner ou vibrer votre traceur. '
      },
      TITLE: 'Les boutons d\'interaction avec le traceur'
    },
    MAP_INTERVAL: {
      COMMON_TEXT: 'Ce bouton vous permet de choisir à quelle fréquence vous souhaitez recevoir une nouvelle position GPS pour votre traceur. Attention, plus l\'intervalle est court et moins l\'autonomie du traceur sera élevée.',
      TITLE: 'L\'intervalle de temps entre chaque position GPS'
    },
    MAP_OPTIONS: {
      COMMON_TEXT: 'Ces boutons vous permettent de mofidier le type de carte que vous souhaitez afficher ainsi que de zoomer ou dézoomer.',
      TITLE: 'Les boutons de réglage de la carte'
    },
    MAP_UPDATE: {
      COMMON_TEXT: 'Ce bouton vous permet d\'actualiser la position de votre traceur (pour obtenir une nouvelle position votre traceur doit être connecté au serveur et avoir un signal GPS valide).',
      TITLE: 'Le bouton d’actualisation de la position'
    },
    MODAL: {
      BUTTON_HINT: 'Appuyez sur le bouton pendant 3 secondes jusqu\'à ce que le traceur vibre.',
      HEADLINE: 'Allumez votre traceur en extérieur ou sur le rebord d\'une fenêtre',
      IMAGE_ALT: 'Photo du traceur',
      MAP_HINT: 'Une fois allumé, le traceur s\'affichera sur la carte dans un délai de 5 minutes en moyenne.'
    },
    REMOTE_ASSISTANCE: {
      ASSISTANCE: {
        COMMON_TEXT: 'Si personne ne réagit dans ce délai l\'alerte est transmise à un opérateur'
      },
      EXPLANATION: 'L\'opérateur prend en charge l\'appel et répond au besoin du porteur du traceur. Selon la situation, il peut <1>contacter des proches ou appeler les secours</1>.',
      PRICE: 'L\'option est facturée à 9,99€ par mois et peut être désactivée à tout moment.',
      SOS: {
        COMMON_TEXT: 'Votre proche appuie sur le bouton SOS de son traceur.'
      },
      TIME: {
        COMMON_TEXT: 'Vous êtes prévenus et avez 30 secondes pour réagir à l\'alerte.'
      },
      TITLE: 'Découvrez notre nouvelle option : la téléassistance ',
      USE_CASE: 'Cette option permet de mettre le porteur du traceur en contact avec un plateau de téléassistance spécialisé, disponible 7j/7 et 24h/24.'
    },
    SIDE_PAGES: {
      COMMON_TEXT: {
        PET: 'Dans le volet de gauche, vous pouvez retrouver toutes les pages de gestion et d’utilisation de votre traceur. L’onglet Historique vous permet de consulter les déplacements de votre animal et l’onglet Suivi d’activité de connaître ses dépenses d’énergie. L’onglet Zones vous permet de configurer celles-ci, l’onglet Paramètres contient le profil de votre animal et l’onglet Abonnement vous permet de gérer votre abonnement ainsi que vos options très facilement.',
        SILVER: 'Dans le volet de gauche, vous pouvez retrouver toutes les pages de gestion et d’utilisation de votre traceur. L’onglet Historique vous permet de consulter les déplacements de votre proche et l’onglet Zones vous permet de configurer des périmètres de sécurité.\n L’onglet Paramètres vous permet de configurer le numéro à appeler en cas de SOS ainsi que les messages associés à chaque bouton latéral du traceur. Enfin, l\'onglet Abonnement vous permet de gérer votre abonnement ainsi que vos options très facilement.'
      },
      TITLE: 'Pages additionnelles'
    },
    SKIP: 'Passer le tutoriel',
    SUPERLIVE: {
      COMMON_TEXT: 'Ce bouton vous permet de déclencher le mode "superlive" : une nouvelle position toutes les 10 secondes pendant 5 minutes.',
      TITLE: 'Le bouton "superlive"'
    },
    TUTORIAL_START: {
      BUTTON: 'Poursuivre le tutoriel',
      COMMON_TEXT: 'Super, votre traceur est maintenant prêt à l\'emploi. Continuons avec un rapide tour d\'horizon de votre espace personnel My Weenect.'
    },
    WAITING_GPS_POSITION: 'Recherche d\'une position GPS',
    WAITING_GPS_POSITION_HINT: 'Allumez votre traceur en extérieur'
  },
  optionCardExpired: {
    PROPOSAL: 'Veuillez mettre à jour votre carte bancaire pour continuer de profiter de nos services.',
    UPDATE_CARD: 'Mettre à jour maintenant',
    WARNING: '<1>Attention !</1> Vous ne pouvez pas souscrire à cette option car <1>votre carte bancaire a expiré</1>.'
  },
  optioncancellation: {
    OFFER_ACCEPT_BUTTON: 'Profiter d’un mois offert',
    OFFER_CONFIRMATION_BUTTON: 'Revenir à l’appli',
    OFFER_CONFIRMATION_TEXT: 'Votre option reste active et votre prochain prélèvement aura lieu le {date}.',
    OFFER_CONFIRMATION_TITLE: 'Option mise à jour !',
    OFFER_PREMIUM_TEXT: 'Restez un mois de plus et profitez encore de votre Pack Premium sans frais !',
    OFFER_REFUSE_BUTTON: 'Désactiver quand même',
    OFFER_SERENITY_TEXT: 'Restez un mois de plus et profitez encore de votre Pack Sérénité sans frais !',
    OFFER_TITLE: 'Et si on vous offrait 1 mois gratuit ?',
    PREMIUM_BUTTON: 'Désactiver le Pack Premium',
    PREMIUM_HEADER: 'Pack Premium',
    PREMIUM_QUESTION: 'Pour quelle raison souhaitez-vous désactiver le Pack Premium ?',
    PREMIUM_TITLE: 'Désactiver le Pack Premium',
    REASON_NOT_MATCHING_NEED: 'La garantie ne correspond pas à mon besoin',
    REASON_NO_NEED_FEATURES: 'Je n’ai pas besoin de ces fonctionnalités',
    REASON_NO_USE: 'Je n’utilise plus le traceur',
    REASON_OTHER: 'Autre',
    REASON_OTHER_PLACEHOLDER: 'Dites-nous en plus...',
    REASON_SUBSCRIBED_BY_MISTAKE: 'J’y ai souscrit par erreur',
    REASON_TOO_EXPENSIVE: 'L’option est trop chère',
    SERENITY_BUTTON: 'Désactiver le Pack Sérénité',
    SERENITY_HEADER: 'Pack Sérénité',
    SERENITY_QUESTION: 'Pour quelle raison souhaitez-vous désactiver le Pack Sérénité ?',
    SERENITY_TITLE: 'Désactiver le Pack Sérénité'
  },
  payment: {
    ADD_NEW_PAYMENT_REGULARISE: 'Veuillez enregistrer un nouveau moyen de paiement ou régulariser votre situation.',
    EXPIRACY_CREDIT_CARD_TEXT: 'Veuillez ajouter un nouveau moyen de paiement pour régulariser votre situation.',
    NO_PAYMENT_MEAN_YET: 'Aucun moyen de paiement pour l\'instant.',
    NO_PAYMENT_YET: 'Aucun paiement pour le moment.',
    UPDATE_PAYMENT_REGULARISE: 'Si vous souhaitez continuer à utiliser votre traceur, veuillez le mettre à jour ou en changer dès maintenant.',
    WARNING_ERROR: 'Il semble qu’il y ait un problème avec votre moyen de paiement. \n',
    WARNING_EXPIRACY_CREDIT_CARD: 'Attention, votre carte bancaire a expiré.',
    WARNING_NOT_ENOUGH_FOUNDS: 'Attention, il semble qu’il n’y ait pas les fonds suffisants sur votre compte.\n'
  },
  payments: {
    CARD: {
      ACCEPTED: '(CB, VISA, Mastercard, American Express)',
      DESCRIPTION: '30 jours satisfait ou remboursé',
      NAME: 'Carte de crédit'
    },
    STATUS: {
      CANCELED: 'Annulé',
      ERROR: 'En échec',
      NEW: 'En cours de traitement',
      PAYMENT_ERROR: 'Échec de paiement',
      PAYMENT_ERROR_EXPLAIN_TEXT: 'Il y a eu une erreur lors de votre paiement. Veuillez réessayer dans quelques instants ou contactez',
      PAYMENT_RETRY: ' Réessayer',
      PAYMENT_SAV: 'le service client .',
      PAYMENT_SUCCESS: 'Paiement réussi !',
      PAYMENT_SUCCESS_TEXT: 'Votre paiement a bien été pris en compte. Vous pouvez\nmaintenant commencer votre expérience Weenect !',
      PAYMENT_SUCCESS_TEXT_APP: 'Votre paiement a bien été pris en compte. Vous pouvez\nmaintenant retourner sur l\'application.',
      PENDING: 'En cours de traitement',
      REFUNDED: 'Remboursé',
      SUCCESS: 'Confirmé'
    },
    TRANSFER: {
      DESCRIPTION: '15 jours supplémentaires pour changer d\'avis, soit 30 jours satisfait ou remboursé',
      NAME: 'Prélèvement bancaire'
    }
  },
  periods: {
    ALT: {
      MONTH: '1 mois',
      YEAR: '1 an',
      YEAR_plural: '{{count}} ans'
    },
    BASE: {
      MONTH: 'mois',
      YEAR: 'an'
    }
  },
  popinpremium: {
    BADGE_PREMIUM: 'PREMIUM',
    CARDSBLOCK_3D_DESCRIPTION: 'Une vue 3D immersive dans votre historique pour revivre chaque trajet comme si vous y étiez.',
    CARDSBLOCK_3D_TITLE: 'Replay 3D',
    CARDSBLOCK_ACTIVEPLUS_DESCRIPTION: 'Une position ultra-fréquente pour ne rien manquer de ses déplacements.',
    CARDSBLOCK_ACTIVEPLUS_TITLE: 'Mode Active Plus',
    CARDSBLOCK_ALERTS_DESCRIPTION: 'Recevez vos alertes par SMS.',
    CARDSBLOCK_ALERTS_TITLE: 'Alertes par SMS',
    CARDSBLOCK_CONTACTS_DESCRIPTION: 'Partagez le suivi avec jusqu’à 10 proches.',
    CARDSBLOCK_CONTACTS_TITLE: '10 contacts de confiance',
    CARDSBLOCK_HEATMAP_DESCRIPTION: 'Visualisez ses zones favorites et trajets fréquents. ',
    CARDSBLOCK_HEATMAP_TITLE: 'Heatmap des déplacements',
    CARDSBLOCK_MAPS_DESCRIPTION: 'Repérez-le facilement, même en terrain complexe : vue satellite, reliefs et sentiers. ',
    CARDSBLOCK_MAPS_TITLE: 'Cartes satellite & 3D',
    CARDSBLOCK_SHARE_DESCRIPTION: 'Invitez vos proches en toute sécurité, sans donner votre mot de passe.',
    CARDSBLOCK_SHARE_TITLE: 'Partagez l’accès à votre compte',
    CARDSBLOCK_SUPERLIVE_DESCRIPTION: 'Localisez votre animal chaque seconde, plus longtemps. \nFonction standard : jusqu’à 2 min',
    CARDSBLOCK_SUPERLIVE_TITLE: 'Superlive jusqu\'à 30 min',
    CARDSBLOCK_TITLE: 'Ce que vous débloquez',
    CTA: 'Essayer 1 mois gratuitement',
    DESCRIPTION: 'Profitez de toutes les fonctions Premium - gratuitement pendant 1 mois. \nSans engagement, résiliable en 1 clic. ',
    REASSURANCEBLOCK_1MONTHFREE: '1 mois offert',
    REASSURANCEBLOCK_BADGE: 'SANS ENGAGEMENT',
    REASSURANCEBLOCK_CANCELABLE: 'Résiliable en 1-clic',
    REASSURANCEBLOCK_FREETODAY: '{{value}} aujourd\'hui',
    REASSURANCEBLOCK_PERMONTH: 'puis {{value}}/mois',
    REASSURANCEBLOCK_REMINDER: 'Rappel avant la fin',
    SUBTITLE_CTA: 'Puis {{value}} /mois · sans engagement · offre non valable si vous en avez déjà bénéficié',
    TITLE: 'Débloquez l\'expérience GPS premium'
  },
  popinserenity: {
    ASSISTANCEBLOCK_FOOTER: 'Un accompagnement humain, à chaque étape',
    ASSISTANCEBLOCK_GUIDE: 'Guide de recherche selon votre pays',
    ASSISTANCEBLOCK_INTRO: 'Et si votre animal disparaît, nous agissons à vos côtés :',
    ASSISTANCEBLOCK_ONLINEAD: 'Diffusion d\'une annonce en ligne',
    ASSISTANCEBLOCK_OVERLINE: 'ASSISTANCE PRIORITAIRE',
    ASSISTANCEBLOCK_PHONEFOLLOWUP: 'Suivi téléphonique de nos conseillers',
    ASSISTANCEBLOCK_POSTER: 'Affiche personnalisée à imprimer',
    ASSISTANCEBLOCK_PRIORITYSUPPORT: 'Assistance SAV prioritaire en cas d\'urgence',
    ASSISTANCEBLOCK_TITLE: 'Une équipe pour le retrouver',
    BADGE_NOCOMMITMENT: 'SANS ENGAGEMENT',
    BADGE_SERENITY: 'PACK SÉRÉNITÉ',
    CTA: 'Activer le Pack Sérénité',
    DESCRIPTION: 'Une protection complète pour votre traceur et une équipe qui vous épaule activement si votre animal se perd.',
    PRICE_PERMONTH: '{{price}} /mois',
    PRICE_PREFIX: 'Pour',
    PROTECTIONBLOCK_BREAKAGE: 'Casse accidentelle',
    PROTECTIONBLOCK_DESCRIPTION: 'Perte, vol ou casse : nous vous renvoyons un traceur neuf.',
    PROTECTIONBLOCK_FOOTER: 'Jusqu\'à 3 remplacements · {{shipping_price}} d\'expédition',
    PROTECTIONBLOCK_LOSS: 'Perte du traceur',
    PROTECTIONBLOCK_OVERLINE: 'PROTECTION',
    PROTECTIONBLOCK_THEFT: 'Vol du traceur',
    PROTECTIONBLOCK_TITLE: 'Votre traceur, remplacé en 24h',
    REASSURANCEBLOCK_CANCELABLE: 'Activez ou résiliez en 1 clic',
    REASSURANCEBLOCK_NOCOMMITMENT: 'Sans engagement',
    TITLE: 'Gardez l\'esprit tranquille, quoi qu\'il arrive.'
  },
  popup: {
    premium_pack_popup_flash_description_1_web: 'Lumière fixe, en plus du clignotement déjà inclus.',
    premium_pack_popup_flash_description_2_web: 'Et un éclairage jusqu’à 30 minutes sans interruption.',
    premium_pack_popup_flash_title_web: 'Un autre style de lampe torche, pour encore plus de sécurité (*uniquement sur traceurs XS et XT)',
    premium_pack_popup_map_description_1_web: 'Vue satellite en qualité HD, Reliefs, chemins de forêt et sentiers de randonnée.',
    premium_pack_popup_map_title_web: 'Des cartes additionnelles pour vous adapter à tous les terrains',
    premium_pack_popup_notifications_description_1_web: 'Ajoutez jusqu’à 10 contacts',
    premium_pack_popup_notifications_description_2_web: 'Crédit de 40 SMS par mois.',
    premium_pack_popup_notifications_description_3_web: 'En plus des notifications pushs et mails, déjà incluses.',
    premium_pack_popup_notifications_title_web: 'Toutes les alertes sur votre téléphone, même sans connexion internet',
    premium_pack_popup_ring_vibrate_description_1_web: 'Au lieu de 10 secondes sans le Pack Premium.',
    premium_pack_popup_ring_vibrate_title_web: 'Sonnerie et Vibreur jusqu’à 30 secondes',
    premium_pack_popup_superlive_description_1_web: 'Au lieu de 2 minutes sans le Pack Premium.',
    premium_pack_popup_superlive_title_simplified_web: 'Superlive jusqu’à 30 min sans interruption'
  },
  powersavingarea: {
    ACTIVE_STATE: 'Active',
    AIRPLANE_MODE: 'Mode avion',
    AIRPLANE_MODE_STATE_DISABLED: 'Désactivé',
    AIRPLANE_MODE_STATE_ENABLED: 'Activé',
    INACTIVE_STATE: 'Inactive',
    REDIRECT_APPLICATION: 'La modification, la création de zones et l\'activation du mode avion se font directement depuis l’application mobile Weenect.'
  },
  premium_pack_popup_flash_description_1: 'Lumière fixe, en plus du clignotement déjà inclus.',
  premium_pack_popup_flash_description_2: 'Et un éclairage jusqu’à 30 minutes sans interruption.',
  premium_pack_popup_flash_title: 'Un autre style de lampe torche, pour encore plus de sécurité (*uniquement sur traceurs XS et XT)',
  premium_pack_popup_map_description_1: 'Vue satellite en qualité HD, Reliefs, chemins de forêt et sentiers de randonnée.',
  premium_pack_popup_map_title: 'Des cartes additionnelles pour vous adapter à tous les terrains',
  premium_pack_popup_notifications_description_1: 'Ajoutez jusqu’à 10 contacts',
  premium_pack_popup_notifications_description_2: 'Crédit de 40 SMS par mois.',
  premium_pack_popup_notifications_description_3: 'En plus des notifications pushs et mails, déjà incluses.',
  premium_pack_popup_notifications_title: 'Toutes les alertes sur votre téléphone, même sans connexion internet',
  premium_pack_popup_ring_vibrate_description_1: 'Au lieu de 10 secondes sans le Pack Premium.',
  premium_pack_popup_ring_vibrate_title: 'Sonnerie et Vibreur jusqu’à 30 secondes',
  premium_pack_popup_superlive_description_1: 'Au lieu de 2 minutes sans le Pack Premium.',
  premium_pack_popup_superlive_title_simplified: 'Superlive jusqu’à 30 min sans interruption',
  premium_pack_popup_title: '<strong>Accédez</strong> au Pack Premium <strong>gratuitement</strong>',
  register: {
    EMAIL_PLACEHOLDER: 'Adresse e-mail',
    ERROR_EMAIL_ALREADY_USED: 'Cette adresse email est déjà associée à un compte',
    FAILED_DESCRIPTION: 'Veuillez vous reconnecter en entrant vos identifiants. ',
    FAILED_TITLE: 'Votre compte a été créé ! ',
    FIRSTNAME_PLACEHOLDER: 'Prénom',
    LASTNAME_PLACEHOLDER: 'Nom',
    LOGIN_CTA: 'Connexion',
    LOGIN_PROMPT_TITLE: 'Déjà client ?',
    PASSWORD_CONFIRM_PLACEHOLDER: 'Confirmation de mot de passe',
    PASSWORD_PLACEHOLDER: 'Mot de passe',
    PHONE_PLACEHOLDER: 'Numéro de téléphone',
    SUBMIT_CTA: 'Créer mon compte',
    TITLE: 'Créer un compte'
  },
  registerSummaryTable: {
    BILLED_MONTH: 'Le paiement est mensuel',
    BILLED_NOW: 'Facturé immédiatement',
    BILLED_THREE_YEARS: 'Le paiement se fait une fois tous les trois ans',
    BILLED_TWO_YEARS: 'Facturé une fois tous les deux ans',
    BILLED_YEAR: 'Le paiement se fait une fois par an',
    HINT_OPTIONS_PRICE: 'Les options, d\'un montant de {{amount}}, seront facturées séparément de l\'abonnement d\'ici deux heures.',
    OPTION_UPGRADE: 'Ajouter l\'option {{name}} pour seulement {{price}} / {{period}}',
    PAY_HINT: 'Cliquez sur le bouton "Payer et activer" et payez {{subscriptionPrice}} pour l\'abonnement.',
    SUBSCRIPTION_UPGRADE: 'Changez pour un abonnement 2 ans et économisez {{amount}} chaque année.',
    TOTAL: 'Total TTC'
  },
  registerTracker: {
    BUY_LINK: 'Vous n\'avez pas encore de traceur Weenect ? <1>Vous pouvez en acheter un ici</1>',
    ERRORS: {
      UNKNOWN: 'Un problème est survenu lors de l\'activation de votre traceur, veuillez réessayer'
    },
    HEADLINE: 'Activer un nouveau traceur',
    IMEI_INPUT: {
      LABEL: 'Numéro IMEI',
      PLACEHOLDER: 'Vous trouverez le numéro IMEI au dos de votre traceur.'
    },
    NAME_INPUT: {
      LABEL: 'Nom du traceur',
      PLACEHOLDER: 'Nom du traceur'
    }
  },
  remoteAssistance: {
    BASE: 'Téléassistance 7j/7 24h/24',
    FEATURES: 'Après une pression du bouton SOS, sans réponse de votre part pendant 30 secondes, l’alerte SOS et l’appel vocal sont automatiquement transmis, 7j/7 et 24h/24, vers notre centrale de téléassistance. Nos agents sont habilités à contacter les secours comme la police ou le SAMU.',
    FORM: {
      ADDRESS_INPUT: {
        LABEL: 'Adresse',
        PLACEHOLDER: 'Nom et numéro de voie'
      },
      BACK: 'Annuler',
      CITY_INPUT: {
        LABEL: 'Ville',
        PLACEHOLDER: ''
      },
      EXTRA_PHONE: {
        LABEL: 'Téléphone secondaire (optionnel)',
        PLACEHOLDER: ''
      },
      HEADLINE: 'Inscription à la téléassistance',
      NAME_INPUT: {
        LABEL: 'Nom complet',
        PLACEHOLDER: 'Prénom NOM'
      },
      PHONE: {
        LABEL: 'Téléphone',
        PLACEHOLDER: ''
      },
      POSTAL_CODE_INPUT: {
        LABEL: 'Code postal',
        PLACEHOLDER: ''
      },
      SAVE: 'Confirmer',
      TERMS: 'J\'ai lu et j\'accepte les <1>conditions d\'utilisation</1> du service',
      TEXT: 'Renseignez les informations de votre proche (le porteur du traceur). Elles permettront à nos agents de lui venir en aide en cas d\'alerte SOS.'
    },
    PENDING: {
      WAITING_FOR_CALL_TEST: 'Formulaire d\'inscription validé. En attente de l\'appel de test.\nVous devez maintenant effectuer un appel de test afin de finaliser l\'activation de l\'option. Référez-vous à l\'email qui vous a été adressé pour connaître la procédure à suivre.',
      WAITING_FOR_RESIGN: 'Désactivation de l\'option en cours.\nVotre demande de désactivation de l\'option a bien été reçue. Nos agents s\'occupent actuellement des formalités administratives. La désactivation sera effective d\'ici peu.',
      WAITING_FOR_VALIDATION: 'Formulaire d\'inscription en cours de validation. \nLes informations que vous avez renseignées lors de votre souscription à l\'option sont actuellement vérifiées par nos agents. Dès que ces informations seront validées nous pourrons passer à la dernière étape d\'activation de l\'option : un appel de test devra être effectué afin de vérifier que tout fonctionne correctement.'
    },
    USER_PHONE: {
      TEXT: 'Renseignez vos informations. Elles permettront à nos agents de vous contacter en cas d\'alerte SOS.'
    }
  },
  replacetracker: {
    ERROR_ALREADY_LINKED: 'Ce traceur est déjà relié à un compte',
    ERROR_INVALID: 'Numéro IMEI invalide',
    ERROR_TYPE_MISMATCH: 'Impossible de remplacer un traceur pour animal par un traceur pour personne, et inversement.',
    IMEI_PLACEHOLDER: 'Numéro IMEI',
    NEW_IMEI_LABEL: 'Saisissez l’IMEI du nouveau traceur :',
    POPIN_ADD_CTA: 'Ajouter un traceur',
    POPIN_ADD_DESCRIPTION: 'Pour suivre un animal ou un proche supplémentaire. Un nouveau traceur nécessite son propre abonnement, et vos traceurs actuels restent actifs.',
    POPIN_ADD_TITLE: 'Ajouter un traceur :',
    POPIN_REPLACE_CTA: 'Remplacer un traceur',
    POPIN_REPLACE_DESCRIPTION: 'Pour changer de traceur sans modifier votre abonnement. Idéal si votre traceur est perdu ou cassé, ou pour passer à un modèle plus récent. L\'ancien traceur est désactivé.',
    POPIN_REPLACE_TITLE: 'Remplacer un traceur :',
    POPIN_TITLE: 'Ajouter ou remplacer un traceur',
    SELECT_TRACKER_LABEL: 'Sélectionnez le traceur à remplacer :',
    SUBMIT_CTA: 'Remplacer',
    SUBTITLE: 'L’abonnement actuel et les paramètres seront transférés sur le nouveau traceur après le remplacement. L’historique des positions GPS du précédent traceur sera perdu.',
    TITLE: 'Remplacer un traceur',
    TRACKER_IMEI: 'IMEI : {{imei}}'
  },
  safetyarea: {
    REDIRECT_APPLICATION: 'La modification et la création de zones se font directement depuis l’application mobile Weenect.'
  },
  santevet: {
    ADVANTAGE: {
      FIRST: '<span>6 mois d\'abonnement Weenect offerts</span> à la souscription',
      PROMO_CODE: 'avec le code',
      SECOND: '<span>20€ de prévention offerts/an</span> en plus du forfait déjà inclus'
    },
    FOOTER: {
      BUTTON: 'Voir les prix',
      TEXT: 'En continuant, vous acceptez d\'être contacté par Santévet.'
    },
    OFFERS: {
      BILL: {
        TEXT: 'De <span>60% à 100%</span> et jusqu’à 2 500€/an.',
        TITLE: 'Vos frais remboursés en cas de maladies et accidents'
      },
      CROSS: {
        TEXT: 'Bénéficiez <span>gratuitement</span> et à <span>tout moment</span> d’une assistance téléphonique.',
        TITLE: 'Un service d\'urgence vétérinaire 24/7'
      },
      MONEY_PUSH: {
        TEXT: 'Santévet avance <span>gratuitement</span> vos frais à la fin de la consultation.',
        TITLE: 'L\'avance de vos frais vétérinaires avec Payvet'
      },
      SERINGE: {
        TEXT: '<span>Jusqu\'à 150€/an</span> pour les soins préventifs (vaccins, antiparasitaires, etc).',
        TITLE: 'Un forfait prévention inclus dans toutes les offres'
      },
      TITLE: 'Les + de Santévet :'
    },
    SUBTITLE: 'et profitez d\'avantages exclusifs',
    TITLE: 'Assurez {{name}} pour seulement {{amount}} €/mois',
    TITLE_WITHOUT_PRICE: 'Assurez {{name}} dès maintenant'
  },
  share_account_link_expired_popin_text: 'Le lien de connexion que vous utilisez a expiré. Veuillez en générer un nouveau afin de vous connecter.',
  share_account_link_expired_popin_title: 'Lien expiré',
  signup: {
    ALREADY_MEMBER_TEXT: 'Déjà utilisateur ?',
    CREATE_ACCOUNT_HEADLINE: 'Créer un compte',
    LOGIN_TEXT: 'Me connecter',
    MARKETING_AGREEMENT_TEXT: 'J\'accepte de recevoir des offres et promotions des partenaires de Weenect',
    RETRY: 'Réessayer',
    SIGNUP_ERRORS: {
      EMAIL_ALREADY_EXISTS: 'Cette adresse mail est déjà associée à un compte',
      POPIN_EMAIL_ALREADY_EXIST: ' <1>Oups</1>, cette adresse email semble déjà être utilisée.',
      UNKNOWN: 'La connexion a échoué, réessayez'
    },
    SIGN_IN_TEXT: 'Connexion',
    SUBMIT_BUTTON: 'Créer mon compte',
    TERMS_AGREEMENT_TEXT: 'J\'accepte <1>les conditions d\'utilisation</1> du service'
  },
  simInfo: {
    TITLE: 'Numéro SIM'
  },
  subOptions: {
    CANCEL: {
      EXPIRATION_DATE: 'Cette option sera toujours active jusqu\'au {{date}}',
      HEADLINE: 'Souhaitez-vous annuler l\'option {{option}} ?'
    },
    MAP: {
      BASE: 'Pack multi-cartes',
      FEATURES: 'Bénéficiez des cartes les plus complètes et récentes : satellite HD et mis à jour très régulièrement, reliefs, chemins de forêt et sentiers.',
      TITLE: 'Cartes premium :'
    },
    PREMIUM: {
      BASE: 'Pack Premium',
      BUTTON: {
        FREEMONTH: 'Essayer gratuitement pendant 1 mois !'
      },
      DEACTIVATE: 'En désactivant cette option vous perdrez vos avantages premium.',
      FEATURE: {
        CHAT: {
          BASE: 'Chat en ligne',
          TEXT: 'Discutez en direct avec un conseiller Weenect, depuis votre application. Service disponible 7j/7, de 9h à 18h.'
        },
        SMS: {
          TEXT: 'Recevez toutes les alertes par SMS (crédit de 40 SMS par mois), en plus des notifications pushs et mails déjà incluses dans l\'abonnement.'
        }
      },
      FEATURE_TEXT: 'Profitez d\'avantages exclusifs (alertes SMS, cartes HD) au sein de l\'application.',
      FREEMONTH: {
        BASE: 'Premier mois offert !',
        BASE2: 'OFFERT'
      },
      SUBTITLE: 'Le Pack Premium comprend les fonctionnalités suivantes : ',
      SUB_LEGAL: 'Cette adhésion sera renouvelée automatiquement chaque mois, via le moyen de paiment choisi lors de la prise de votre abonnement. Vous pouvez annuler l’adhésion à tout moment via votre espace personnel.',
      TEXT_INFO_PRICE: 'Puis {{price}}/mois après le premier mois.',
      TITLE_DISCOVER: 'Découvrez vos avantages exclusifs : ',
      TITLE_POPUP: 'Devenez membre Premium !'
    },
    SMS_PACK: {
      ALT_FEATURES: {
        one: 'Recevez toutes les alertes par SMS (20 SMS disponibles par mois).',
        other: ''
      },
      BASE: 'Pack SMS',
      FEATURES: {
        one: 'Recevez toutes les alertes par SMS (20 SMS disponibles par mois). Notez que sans cette option vous recevrez bien les alertes par pushs (application) et mails.',
        other: ''
      }
    },
    UNDEFINED: {
      PAYMENTS: 'Paiement pour l\'option'
    },
    WARRANTY: {
      ALT_FEATURES: {
        one: 'Obtenez gratuitement un nouveau traceur en cas de casse, perte ou vol de votre traceur actuel.',
        other: 'Payez par carte de débit avec annulation possible à tout moment',
        two: 'Votre traceur remplacé en 48H en cas de perte, casse ou vol, sans conditions.'
      },
      BASE: 'Garantie multi-risques',
      EXPLAINER: 'La garantie standard couvre uniquement les problèmes de fabrication du traceur.',
      FEATURES: 'Obtenez gratuitement un traceur de remplacement en cas de casse, perte ou vol de votre traceur actuel ; aucune justification n’est demandée. La garantie standard couvre uniquement les problèmes de fabrication du traceur.'
    }
  },
  subscription: {
    ADD_A_PROMO_CODE: 'Ajouter un code promotionnel',
    CANCEL_PAGE: {
      BUTTON: 'Réessayer',
      TEXT: 'Votre paiement a été annulé',
      TITLE: 'Paiement annulé'
    },
    COMMON_TEXT: {
      MONTH: '/ mois',
      OR: 'Soit'
    },
    FAIL_PAGE: {
      BUTTON: 'Réessayer',
      TEXT: 'Votre paiement n’a pas abouti. Nous vous invitons à réessayer.',
      TITLE: 'Échec du paiement'
    },
    FEATURES: {
      APP_ACCESS: 'Accès à l\'application et au service de localisation en illimité',
      REFOUND: '15 jours d\'essai : satisfait ou remboursé',
      SAV: 'Service client disponible 6/7 jours. \nRéponse garantie sous 24h.',
      WARRANTY: 'Garantie constructeur 24 mois'
    },
    FIRST_PAGE: {
      BANNER_NEW_PRICES_DESCRIPTION: 'Les tarifs affichés ci-dessous s\'appliquent jusqu\'à la fin de votre période d\'engagement. Aux prochains renouvellements après le 1er juillet 2026, le nouveau tarif sera appliqué.',
      BANNER_NEW_PRICES_TITLE: 'Nouveaux tarifs au 1er juillet 2026',
      BUTTON: 'Suivant',
      BY_YEAR: 'soit {{price}} /an',
      DETERRENT_MONTHLY_POPIN: {
        BUTTON: {
          CHANGE: 'Changer d\'offre',
          CONTINUE: 'Continuer quand même'
        },
        DESCRIPTION: 'Cette formule n\'a pas de période de rétractation, et ne permet pas d\'avoir la garantie à vie sur votre traceur.\nOptez plutôt pour l\'abonnement 1 an !',
        TITLE: 'Êtes-vous sûr de prendre l\'abonnement mensuel ?'
      },
      FOR_YEAR: 'soit {{price}} pour {{period}} ans',
      MODAL_GIFT_CARD: {
        BUTTON: 'Appliquer',
        DELETE_BUTTON: 'Supprimer',
        ERROR: 'Le numéro de carte cadeau entré est invalide',
        INPUT_LABEL: 'Carte cadeau',
        TITLE: 'Ajouter une carte cadeau'
      },
      MODAL_INFORMATION: {
        TEXT: 'La carte SIM directement intégrée dans votre traceur nécessite la souscription à un abonnement (afin de couvrir les frais de service).',
        TITLE: 'Pourquoi choisir un abonnement ?'
      },
      SUBSCRIPTION_CGV: {
        FIRST_TEXT: 'Tous les abonnements sont payés en une fois et reconduits automatiquement selon la période choisie. Vous pouvez annuler à tout moment cette reconduction, avant la fin de chaque période en cours.',
        INCLUDES: {
          FIRST: 'satisfait ou remboursé',
          FIRST_BOLD: '15 ou 30 jours d\'essai minimum selon l’abonnement :',
          FOURTH: 'constructeur 24 mois minimum',
          FOURTH_BOLD: 'Garantie',
          SECOND: 'et au service de localisation en illimité.',
          SECOND_BOLD: 'Accès à l\'application',
          THIRD: 'disponible 6/7 jours. Réponse garantie sous 24h',
          THIRD_BOLD: 'Service client'
        },
        SECOND_TEXT: 'Pour bénéficier des abonnements, vous devez saisir des informations bancaires valides et accepter les',
        SECOND_TEXT_LINK: 'conditions générales d’utilisation du service.',
        TITLE: 'Tous les abonnements incluent:'
      },
      SUBSCRIPTION_CHOICE: {
        CHIP_BEST_OFFER: 'Meilleure offre',
        CHIP_ECO_OFFER: 'Offre économique',
        CHIP_ONE_MONTH: 'Offre flexible',
        CHIP_ONE_YEAR: 'Offre populaire',
        CHIP_POPULAR_OFFER: 'Offre populaire',
        CHIP_THREE_YEAR: 'Économisez {{count}}%',
        SEE_MORE: 'Voir plus d\'abonnements',
        SUBSCRIPTION_TITLE_GIFT_CARD: 'J’ai une carte cadeau',
        SUBSCRIPTION_TITLE_MONTHLY: 'Abonnement mensuel',
        SUBSCRIPTION_TITLE_one: 'Abonnement {{count}} an',
        SUBSCRIPTION_TITLE_other: 'Abonnement {{count}} ans',
        TIP_30_DAYS_WARRANTY: '🛡️ Satisfait ou remboursé : vous avez 30 jours pour changer d’avis.',
        TIP_ONE_MONTH: '⚠️ Economisez {{price}} en choisissant l’abonnement 1 an.',
        TIP_ONE_MONTH_ALT: '⚠️ L\'abonnement mensuel vous ferait perdre {{loss}} sur un an.',
        TIP_ONE_YEAR: '💡 Economisez {{savings}}% en choisissant l’abonnement 3 ans.',
        TIP_THREE_YEAR: '🛡️ Garantie "satisfait ou remboursé" étendue : vous avez 30 jours pour changer d’avis.',
        TIP_TWO_YEAR: '💡 Bénéficiez d\'un an supplémentaire pour seulement {{additional_cost}} de plus, en choisissant l\'abonnement 3 ans.',
        TITLE: 'Choisissez votre abonnement'
      },
      SUBTITLE: 'Les abonnements sont garantis "satisfait ou remboursé" : vous avez 15 jours pour changer d\'avis.'
    },
    FOR_MINUS_X_PERCENT: 'à -{{percent}}%',
    FREE: 'OFFERT',
    HEADER: {
      STEP: 'Étape',
      TITLE: {
        FIRST_PAGE: 'Abonnement',
        SECOND_PAGE: 'Options',
        THIRD_PAGE: 'Paiement'
      }
    },
    HOME_PAGE: {
      TITLE: 'Chargement'
    },
    INFO_CGU: 'Pour bénéficier des abonnements, vous devez saisir des informations bancaires valides et accepter',
    INFO_CGU_BUTTON: 'les conditions générales d’utilisation du service.',
    INFO_OPTION: 'Vous pouvez désélectionner une option en cliquant dessus.',
    MANAGE: {
      SERENITY_PACK: {
        DESCRIPTION1: 'Assistance prioritaire et remplacement de votre traceur en cas de perte, casse ou vol - sans justificatif.',
        DESCRIPTION2: 'Si votre animal disparait malgré son traceur : accompagnement de notre équipe avec la création d\'outils de diffusion pour retrouver votre animal.',
        TITLE: 'Pack Sérénité'
      }
    },
    MANAGE_MEAN: {
      MEAN: {
        CARD: 'Carte bancaire',
        DIRECT_DEBIT: 'Prélèvement bancaire',
        EDIT: 'Modifier',
        EXPIRED: '⚠️ Ce moyen de paiement a expiré.\nCliquez dessus pour le reconfigurer ou ajouter un nouveau moyen de paiement.',
        EXPIRY_DATE: 'Date d\'expiration',
        INVALID: '⚠️ Ce moyen de paiement a été désactivé suite à plusieurs échecs de paiement.\nSélectionnez-le pour le reconfigurer ou ajoutez un nouveau moyen de paiement.',
        NO_MEAN: {
          BUTTON: 'Ajouter un moyen de paiement',
          TITLE: 'Vous n\'avez aucun moyen de paiement enregistré.'
        },
        NO_REFERENCE: 'Modifier le moyen de paiement',
        SUBTITLE: 'Le moyen de paiement enregistré ci-dessous sera utilisé pour le renouvellement de vos abonnements et options.\nCliquez dessus pour le modifier.',
        TITLE: 'Gérer votre moyen de paiement'
      },
      TITLE: 'Moyen de paiement et factures'
    },
    MANAGE_PAGE: {
      ACCOUNT_OPTIONS: {
        DESCRIPTION: 'Les options du compte sont appliquées à tous les traceurs de votre compte.',
        PREMIUM_PACK: {
          DESCRIPTION: '- Superlive jusqu’à 30 min\n- Cartes supplémentaires pour s’adapter à tous les terrains\n- Heatmap des déplacements\n- Alertes par SMS\n- 10 contacts de confiance\n- Partage de l’accès à votre compote\n- Mode Active Plus\n- Replay 3D',
          TITLE: 'Pack Premium'
        },
        TITLE: 'Options du compte',
        WARRANTY: {
          DESCRIPTION: '💡 Assistance prioritaire et remplacement de votre traceur en cas de perte, casse ou vol - sans justificatif. \nSi votre animal disparait malgré son traceur : accompagnement de notre équipe avec la création d\'outils de diffusion pour retrouver votre animal.',
          TITLE: 'Pack Sérénité'
        }
      },
      ACTIVATE: {
        BUTTON: 'Activer'
      },
      ADD_SUBSCRIPTION_BUTTON: 'Choisir un abonnement',
      CANCEL: {
        BUTTON: 'Résilier'
      },
      CANCEL_CONFIRM: {
        GENERIC: {
          BUTTON: {
            CONTINUE_CANCELLATION: 'Continuer',
            KEEP_ADVANTAGES: 'Conserver mes avantages'
          },
          TITLE: 'Êtes-vous sûr ?'
        },
        OPTION: {
          PREMIUM_PACK: {
            SUBTITLE: 'En désactivant le renouvellement du Pack Premium, vous perdrez les avantages suivants à partir du {{date}} :'
          },
          WARRANTY: {
            SUBTITLE: 'En désactivant le renouvellement de votre Pack Sérénité, vous perdrez les avantages suivants à partir du {{date}} :'
          }
        },
        SUBSCRIPTION: {
          ADVANTAGES: {
            DESCRIPTION: '- Accès aux services Weenect pour ce traceur\n- Garantie constructeur à vie de votre traceur'
          },
          SUBTITLE: 'En désactivant le renouvellement de votre abonnement, vous perdrez les avantages suivants <strong>à partir du {{date}} :</strong>'
        }
      },
      EDIT: {
        BUTTON: 'Modifier',
        CANCEL_REVIEW: {
          DETAILS: {
            SUBTITLE: 'Nous aimerions mieux comprendre ce qui n’a pas fonctionné pour vous. Votre avis est précieux et nous aide à améliorer notre service.'
          },
          OPTION: {
            SUBTITLE: {
              PREMIUM_PACK: 'Nous sommes tristes de vous voir partir.\nPour quelle raison souhaitez-vous annuler le renouvellement de votre Pack Premium ?',
              WARRANTY: 'Nous sommes tristes de vous voir partir.\nPour quelle raison souhaitez-vous annuler le renouvellement de votre Pack Sérénité ?'
            },
            TITLE: 'Désactiver le renouvellement de l\'option'
          },
          REASON: {
            AFTER_SALES_SERVICE: 'Mauvaise expérience avec le service client',
            BAD_NETWORK: 'La connexion réseau est mauvaise',
            BAD_PRECISION: 'Mauvaises positions GPS',
            BATTERY: 'Autonomie de la batterie insuffisante',
            LOST_BROKEN: 'J’ai perdu / cassé mon traceur',
            MISSING_FEATURES: 'Il manque une ou plusieurs fonctionnalités',
            MOBILE_APPLICATION: 'L’application ne fonctionne pas',
            NOT_ENOUGH_FEATURES_PREMIUM: 'Pas assez de fonctionnalités (Pack Premium)',
            NOT_SATISFIED: 'Je ne suis pas satisfait',
            NO_USE: 'Je n’utilise plus le traceur',
            OTHER: 'Autre',
            PLACEHOLDER: 'Dites-nous en plus…',
            TOO_EXPENSIVE: 'Abonnement trop cher',
            TOO_EXPENSIVE_OPTION: 'L’option est trop chère',
            TRACKER_FORMAT: 'Traceur trop gros / lourd',
            TRACKER_ISSUE: 'Problèmes avec le traceur',
            WILL_REACTIVATE_LATER: 'Pour suspendre le renouvellement automatique (je souhaite continuer à utiliser le traceur)'
          },
          SUBSCRIPTION: {
            SUBTITLE: 'Nous sommes tristes de vous voir partir.\nPour quelle raison souhaitez-vous annuler le renouvellement de votre abonnement ?',
            TITLE: 'Désactiver le renouvellement de l\'abonnement'
          }
        },
        ERROR: {
          HEADER: 'Erreur',
          SUBTITLE: 'La modification de votre abonnement a échoué. Veuillez réessayer.\nSi le problème persiste, contactez notre service client.',
          TITLE: 'Oups, un problème est survenu.'
        }
      },
      EDIT_OPTION: {
        HEADER: 'Modifier l\'option'
      },
      EDIT_RESULT: {
        BUTTON: 'Retour au menu',
        CANCELLATION_SUCCESS: {
          OPTION: {
            SUBTITLE: 'Le renouvellement automatique de votre option {{option_title}} a bien été annulé.'
          },
          SUBSCRIPTION: {
            SUBTITLE: 'Le renouvellement automatique de votre abonnement a bien été annulé.'
          },
          TITLE: 'Renouvellement automatique annulé'
        },
        CHANGE_SUBSCRIPTION: {
          SUCCESS: {
            SUBTITLE: 'Votre abonnement sera renouvelé le <strong>{{next_charge_at}}</strong> au tarif de <strong>{{upgrade_amount}}</strong> pour la formule <strong>{{update_offer_title}}</strong>.',
            TITLE: 'Changement d\'abonnement réussi !'
          }
        },
        EXTEND_SUCCESS: {
          SUBTITLE: 'Nous sommes ravis de continuer à protéger {{tracker_name}}.\nVotre abonnement est prolongé jusqu\'au <strong>{{next_charge_at}}</strong>.',
          TITLE: 'Abonnement prolongé !'
        },
        OFFER_SUCCESS: {
          CREATE_TICKET: {
            SUBTITLE: 'Votre demande d\'assistance prioritaire a été enregistrée.\nUn de nos conseillers vous contactera très bientôt pour résoudre votre problème.',
            TITLE: 'Demande enregistrée'
          },
          FREE_MONTHS: {
            SUBTITLE: 'Nous sommes ravis de continuer à protéger {{tracker_name}}.\nVotre prochain renouvellement aura lieu le <strong>{{next_charge_at_with_free_months}}</strong>.',
            TITLE: 'Abonnement mis à jour !'
          },
          UPGRADE: {
            SUBTITLE: 'Nous sommes ravis de continuer à protéger {{tracker_name}}.\nVotre abonnement sera renouvelé le <strong>{{next_charge_at}}</strong> au tarif de <strong>{{upgrade_amount}}</strong> pour la formule <strong>{{update_offer_title}}</strong>.',
            TITLE: 'Abonnement mis à jour !'
          }
        }
      },
      EDIT_SUBSCRIPTION: {
        CANCEL: {
          SUBTITLE: 'Votre abonnement ne sera plus renouvelé automatiquement.\nVous perdrez l\'accès à vos services le {{date}}.',
          TILE: 'Désactiver le renouvellement',
          TITLE: 'Désactiver le renouvellement ?'
        },
        CHANGE: {
          SUBTITLE: 'Le changement d’abonnement sera effectué à la fin de la période en cours.',
          SUCCESS: {
            BUTTON: 'Retour au menu',
            SUBTITLE: 'Votre abonnement sera renouvelé avec la formule suivante :\n<strong>{{new_offer_title}}</strong>\nLa facturation et le renouvellement avec cette formule auront lieu le <strong>{{date}}</strong>.',
            SUBTITLE_1: 'Votre abonnement sera renouvelé avec la formule suivante :',
            SUBTITLE_2: 'La facturation et le renouvellement avec cette formule auront lieu le {{date}}.',
            TITLE: 'Changement d\'abonnement enregistré !'
          },
          TITLE: 'Changer d\'abonnement ?'
        },
        ERROR: {
          SUBTITLE: 'L\'action n\'a pas été prise en compte.\nVeuillez réessayer plus tard.',
          TITLE: 'Erreur'
        },
        HEADER: 'Modifier l\'abonnement',
        OVERCHARGE_PER_YEAR: 'vous perdez {{price}} / an',
        SAVINGS_PER_YEAR: 'vous économisez {{price}} / an'
      },
      EXTEND: {
        BUTTON: 'Prolonger',
        MODAL: {
          DESCRIPTION: 'La durée de votre carte cadeau sera ajoutée à l\'abonnement de {{tracker_name}}.',
          ERROR: {
            INVALID: 'Cette carte cadeau est invalide ou a déjà été utilisée.',
            NOT_ELIGIBLE: 'Cette carte cadeau ne permet pas de prolonger un abonnement. Utilisez-la lors d\'une nouvelle souscription.'
          },
          TITLE: 'Prolonger avec une carte cadeau'
        }
      },
      FIRST_MONTH_FREE: '1er mois offert',
      INVALID_PAYMENT_MEAN_POPIN: {
        BUTTON: 'Mettre à jour mon moyen de paiement',
        SUBTITLE: {
          ERRORS: 'Votre moyen de paiement est invalide.\nCliquez sur le bouton ci-dessous pour le mettre à jour.',
          EXPIRED: 'Votre moyen de paiement est expiré.\nCliquez sur le bouton ci-dessous pour le mettre à jour.',
          MISSING: 'Aucun moyen de paiement n\'est enregistré sur votre compte.\nCliquez sur le bouton ci-dessous pour en ajouter un.'
        },
        TITLE: {
          OPTION: 'Impossible de réactiver votre option',
          SUBSCRIPTION: 'Impossible de réactiver votre abonnement'
        }
      },
      NO_SUBSCRIPTION: 'Ce traceur n\'a pas d\'abonnement.',
      OPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Cette option est active et sera automatiquement renouvelée le {{date}} pour {{period}} à {{price}}.',
          DESCRIPTION_PAST: 'Cette option est active et sera prochainement facturée pour {{period}} à {{price}}.',
          TITLE: 'Renouvellement automatique actif'
        },
        ACTIVE_NO_DATE: {
          DESCRIPTION: 'Cette option est active.'
        },
        CANCELED: {
          DESCRIPTION: 'Le renouvellement de cette option est désactivé. L’accès aux fonctionnalités est toujours possible jusqu’au {{date}}, mais passé cette date, celles-ci ne seront plus accessibles.',
          TITLE: 'Renouvellement automatique désactivé'
        },
        EXPIRED: {
          DESCRIPTION: 'Cette option a expiré. Veuillez la réactiver pour retrouver l\'accès aux fonctionnalités associées.'
        }
      },
      REACTIVATE: {
        BUTTON: 'Réactiver le renouvellement'
      },
      RETENTION_OFFERS: {
        BUTTON: {
          ACCEPT: 'Accepter',
          CONTINUE_CANCELLATION: 'Continuer l\'annulation'
        },
        CREATE_TICKET: {
          BUTTON: 'Être rappelé',
          DESCRIPTION: 'Créez une demande prioritaire et notre service après-vente vous contacte en premier — pas de file d\'attente, une réponse rapide et personnalisée.',
          TITLE: 'Besoin d\'aide ?\nUn conseiller vous rappelle en priorité'
        },
        FREE_MONTHS: {
          DESCRIPTION: 'Si notre première offre ne correspond pas à vos attentes, nous aimerions vous proposer une seconde offre rien que pour vous : <strong>{{free_months}} mois d\'abonnements offerts !</strong>\n\nVous continuerez donc à protéger {{tracker_name}} gratuitement jusqu’au {{next_charge_at_with_free_months}}.',
          TITLE: '{{free_months}} mois offerts !'
        },
        UPGRADE: {
          BUTTON: 'Économiser {{savings}} en 1 clic',
          DESCRIPTION: 'Parce que nous serions très triste que {{tracker_name}} ne soit plus protégé au quotidien, nous vous proposons une offre exclusive : <strong>{{savings_amount}} d\'économies</strong> sur votre <strong>{{upgrade_offer_title}}</strong>.\n\nVotre abonnement reviendra à <strong>{{upgrade_amount}}, soit {{upgrade_amount_monthly}}</strong>.\n\nCette offre sera appliquée à partir du {{next_charge_at}}, date de renouvellement de votre abonnement actuel.',
          TITLE: '-{{discount_ratio}}% sur votre {{upgrade_offer_title}}'
        }
      },
      SUBSCRIBE_AGAIN: {
        BUTTON: 'Se réabonner'
      },
      SUBSCRIPTION_STATUS: {
        ACTIVE: {
          DESCRIPTION: 'Votre abonnement sera automatiquement renouvelé le {{date}} pour {{period}} à {{price}}.',
          DESCRIPTION_PAST: 'Votre abonnement sera prochainement facturé pour {{period}} à {{price}}.',
          TITLE: 'Renouvellement automatique actif'
        },
        CANCELED: {
          DESCRIPTION: 'Votre abonnement est actif jusqu\'au {{date}} mais ne sera pas renouvelé automatiquement.\nAprès cette date, votre traceur cessera de fonctionner.',
          TITLE: 'Renouvellement automatique désactivé'
        },
        EXPIRED: {
          DESCRIPTION: 'Votre abonnement est expiré.\nVous devez souscrire un nouvel abonnement pour pouvoir utiliser ce traceur.'
        }
      },
      TITLE: 'Abonnement(s) et options',
      TRACKER_SUBSCRIPTIONS_OPTIONS: {
        TITLE: 'Abonnements et options de {{name}}'
      }
    },
    MONEY_BACK: 'Tous les abonnements sont facturés immédiatement mais peuvent être annulés dans un délai de 15 jours, avec un remboursement intégral du montant payé. ',
    MONTH: 'mois',
    ONLY: 'seulement',
    PAYMENTS_LIST: {
      NO_PAYMENTS: {
        TITLE: 'Aucun paiement n\'a été effectué.'
      },
      SUBTITLE: 'Consultez vos derniers paiements ci-dessous.\nCliquez sur l’un d’eux pour télécharger la facture.',
      TITLE: 'Factures'
    },
    PAYMENT_INFO: 'Garantie satisfait ou remboursé : 15 jours pour essayer votre traceur',
    PAYMENT_SUBHEADLINE: 'Réglez votre abonnement pour activer votre traceur.',
    PAYMENT_TITLE: 'Choisissez votre moyen de paiement',
    PAYMENT_TITLE2: 'Enregistrez votre moyen de paiement',
    PENDING_PAGE: {
      BUTTON: 'Annuler',
      TEXT: 'La validation du paiement est en cours ...',
      TIMEOUT_TEXT: 'La validation du paiement semble prendre plus longtemps que prévu.',
      TITLE: 'Paiement en cours'
    },
    PERIOD: {
      MONTH_one: '{{period}} mois',
      MONTH_other: '{{period}} mois',
      YEAR_one: '{{period}} an',
      YEAR_other: '{{period}} ans'
    },
    PREPAYED: '{{price}} payés en une fois',
    PREPAYED_DATE: '{{price}} payés en une fois le {{date}}',
    PRICE_MONTH_SAVED: 'soit {{price}} / mois',
    SECONDE_PAGE: {
      BUTTON: 'Passer au paiement'
    },
    SECOND_PAGE: {
      BASKET: {
        TEXT: {
          premium_pack: 'Premier mois offert puis',
          warranty: 'Le paiement est mensuel.'
        },
        TOTAL: 'Total TTC'
      },
      OPTION_CHOICE: {
        CHIP: '1ER mois offert',
        TEXT: {
          premium_pack: 'Débloquez des fonctionnalités exclusives : Superlive jusqu’à 30min, vues de cartes additionnelles, autre style de lampe torche, ou bien encore alertes par SMS.',
          warranty: 'Assistance prioritaire et remplacement de votre traceur en cas de perte, casse ou vol - sans justificatif. \nSi votre animal disparait malgré son traceur : accompagnement de notre équipe avec la création d\'outils de diffusion pour retrouver votre animal.'
        },
        TITLE: {
          premium_pack: 'Pack Premium',
          warranty: 'Pack Sérénité'
        }
      },
      SUBTITLE: 'Les options sont sans engagement et annulables à tout moment depuis votre application mobile ou votre espace client.',
      TITLE: 'Choisissez vos options'
    },
    SUBSCRIPTION_TITLE: {
      MONTH_one: 'Abonnement mensuel',
      MONTH_other: 'Abonnement {{period}} mois',
      YEAR_one: 'Abonnement annuel',
      YEAR_other: 'Abonnement {{period}} ans'
    },
    SUCCESS_PAGE: {
      BUTTON: 'Revenir à l’appli',
      TEXT: 'Cliquez sur le bouton ci-dessous pour commencer à utiliser votre traceur.',
      TEXT_ASYNC: 'Le prélèvement sera effectué dans quelques jours.\n\n⚠️ En cas de rejet par votre banque, le traceur sera désactivé.\n\nCliquez sur le bouton ci-dessous pour commencer à utiliser votre traceur.',
      TITLE: 'Paiement enregistré'
    },
    SUMMARY: 'Récapitulatif',
    THIRD_PAGE: {
      BUTTON: 'Confirmer et payer',
      MODAL: {
        ERROR: 'Le code promotionnel est invalide',
        TITLE: 'Code promotionnel'
      },
      NO_PROVIDER: 'Aucune méthode de paiement disponible',
      PAYMENT_CHOICE: {
        BANK: 'Prélèvement bancaire',
        CARD: 'Carte de crédit',
        TITLE: 'Choisissez votre moyen de paiement'
      },
      SUBTITLE: 'Sélectionnez une méthode de paiement pour régler votre abonnement et activer votre traceur.'
    },
    TUNNEL: {
      SERENITY_PACK: {
        DESCRIPTION1: 'Assistance prioritaire et remplacement de votre traceur en cas de perte, casse ou vol - sans justificatif.',
        DESCRIPTION2: 'Si votre animal disparait malgré son traceur : accompagnement de notre équipe avec la création d\'outils de diffusion pour retrouver votre animal.',
        TITLE: 'Pack Sérénité'
      }
    },
    UNKNOWN_PAGE: {
      BUTTON: 'Revenir à l\'application',
      TEXT: 'L\'application s\'est retrouvée dans un état imprévu.',
      TITLE: 'Étape inconnue'
    }
  },
  subscriptionAlert: {
    ACTIVATE_AUTO_RENEWAL: 'Réactiver le renouvellement automatique',
    AUTO_RENEWAL_ADVICE: 'Nous vous conseillons de réactiver le renouvellement automatique si vous souhaitez prolonger votre abonnement',
    AUTO_RENEWAL_NOTICE: '<1>Attention !</1> Votre abonnement pour le traceur {{trackerName}} arrive à sa fin et le renouvellement automatique est désactivé.',
    CONTINUE_BUTTON: 'Continuer',
    MESSAGES: {
      UPDATE_ERROR_UNKNOWN: 'Un problème est survenu',
      UPDATE_SUCCESS: 'Mis à jour avec succès'
    },
    REMIND_LATER: 'Me rappeler plus tard',
    SUPPORT_TEXT: 'Si vous avez des questions ou que vous pensez que c\'est une erreur, contactez notre <1>service client</1>.',
    TRIAL_CASE: {
      SUBSCRIBE_BUTTON: 'Prendre un abonnement',
      TRIAL_IS_OVER: 'Votre période d\'essai est terminée',
      TRIAL_IS_OVER_ADVICE: 'Nous espérons que votre essai aura été concluant ! Pour continuer à utiliser le produit, il vous faut désormais prendre un abonnement.'
    }
  },
  subscriptionOptionsSelection: {
    CANCEL_WARNING_MODAL_HEADLINE: 'Êtes-vous sûr de vouloir désactiver cette option ?',
    CANCEL_WARNING_SMS: 'En désactivant cette option vous ne recevrez pas les notifications des alertes par SMS.',
    CANCEL_WARNING_WARRANTY: 'En désactivant cette option vous perdrez la protection supplémentaire apportée par la garantie multi-risques.',
    EXPLANATION: 'Le paiement des options est mensuel.',
    EXPLANATION2: 'Et l\'annulation est possible à tout moment.',
    EXPLANATION3: 'Aucun paiement ne sera effectué.',
    HINT: 'Vous pouvez activer ou désactiver une option à tout moment',
    MAIN_HEADLINE: 'Choisissez vos options',
    SUBMIT_BUTTON: 'Confirmer'
  },
  subscriptionPayment: {
    ERRORS: {
      UNKNOWN: 'Un problème est survenu lors du paiement, veuillez réessayer'
    },
    GIFT_CARD: {
      EXPLANATION: 'Entrez le code écrit au dos de la carte fournie dans votre pack traceur.',
      I_HAVE_ONE: 'J\'ai une carte cadeau',
      NEED_HELP: 'Besoin d\'aide au sujet des cartes cadeaux ?',
      TITLE: 'Utilisez votre cadeau',
      USE: 'Utiliser'
    },
    HEADLINE: 'Récapitulatif avant paiement',
    PROMOCODE_TEXT: 'J\'ai un code promo :',
    PROMO_CODE: 'Code promo',
    PROMO_CODE_GIFT_CARD: 'Carte cadeau',
    SATISFIED_OR_REFUNDED: 'Garantie satisfait ou remboursé',
    SATISFIED_OR_REFUNDED_DESCRIPTION: '30 jours pour l\'essayer sans risque, si vous n\'êtes pas satisfait nous vous remboursons.',
    SELECT_PAYMENT_MEAN: 'Sélectionnez une méthode de paiement avant de payer et activer votre abonnement.',
    SUBMIT_BUTTON: 'Régler l\'abonnement',
    SUBMIT_BUTTON2: 'Activer le traceur',
    SUMMARY: 'Rappel de vos choix'
  },
  subscriptionProcess: {
    GIFT_CARD_EXPLANATION: 'Renseignez votre méthode de paiement préférée pour activer gratuitement votre traceur.',
    GIFT_CARD_EXPLANATION2: 'Cette information est nécessaire pour des raisons légales liées à l\'utilisation des cartes SIM.',
    RETURN_TO_APP: 'Retourner sur l\'application ',
    RETURN_TO_MAP: 'Retourner sur la carte',
    RETURN_TO_TRACKERS: 'Retour à la carte',
    STEPS: [
      'Traceur',
      'Abonnement',
      'Options',
      'Paiement'
    ]
  },
  subscriptionSelection: {
    BEST_OFFER: 'MEILLEURE OFFRE',
    CANCELABLE_AFTER_THREE_MONTHS: 'Annulation possible à tout moment après les trois premiers mois',
    CANCEL_ANYTIME: 'Annulation possible à tout moment',
    COMMITMENT_TEXT: 'Résiliation possible à tout moment à l’issue de la période minimale d\'engagement de 3 mois.',
    FEATURES: '\n[ \'Accès à l\'application et au service de localisation en illimité \',\n  \'Service client disponible 6/7 jours.Réponse garantie sous 24h.\',\n  \'15 jours d\'essai : satisfait ou remboursé\',\n  \'Garantie constructeur 24 mois\'\n]',
    FEATURES_HEADLINE: 'Tous les abonnements incluent :',
    HEADLINE: 'Choisissez votre abonnement',
    MIN_THREE_MONTHS: 'Engagement minimum de trois mois',
    MONEY_BACK: 'Tous les abonnements sont facturés immédiatement mais peuvent être annulés dans un délai de 30 jours, avec remboursement intégral du montant payé.',
    PAYMENT_MEANS: 'Paiement par prélèvement bancaire ou carte de crédit',
    REFUNDED_INFO: 'Nous vous remboursons l\'abonnement sans condition.',
    REFUNDED_TEXT: 'Satisfait ou remboursé 30 jours.',
    SIM_CARD_WARNING: 'Une carte SIM est directement intégrée dans votre traceur. Ceci explique qu’il soit nécessaire de souscrire un abonnement (afin de couvrir les frais de service).',
    SUBMIT_BUTTON: 'Confirmer',
    XMAS_OFFER: {
      BODY: 'Néanmoins nous sommes dans l\'obligation de vous faire choisir votre futur abonnement dès maintenant (par mesure de sécurité, le produit étant équipé d\'une carte SIM). Vous ne serez pas prélevé avant la fin des 6 mois gratuits et pourrez annuler cet abonnement à tout moment jusqu\'à un mois avant sa date de début effectif.',
      TITLE: 'Votre traceur est pré-chargé avec 6 mois d\'abonnement offerts par votre proche'
    },
    features: [
      '30 jours satisfait ou remboursé',
      'Localisation GPS illimitée',
      'Notifications par pushs (application) et mails',
      '10 minutes d\'appel vocal par mois'
    ]
  },
  subscriptioncarousel: {
    CARDSBLOCK_1YEAR_PAYMENT: 'Paiement de {{total_price}} tous les ans.',
    CARDSBLOCK_1YEAR_TITLE: 'Abonnement prépayé 1 an',
    CARDSBLOCK_2YEARS_PAYMENT: 'Paiement de {{total_price}} tous les deux ans.',
    CARDSBLOCK_2YEARS_TITLE: 'Abonnement prépayé 2 ans',
    CARDSBLOCK_5YEARS_PAYMENT: 'Paiement de {{total_price}} tous les cinq ans.',
    CARDSBLOCK_5YEARS_TITLE: 'Abonnement prépayé 5 ans',
    CARDSBLOCK_BADGE_GUARANTEE: 'Satisfait ou remboursé',
    CARDSBLOCK_BADGE_POPULAR: 'Offre populaire',
    CARDSBLOCK_GUARANTEE: 'Satisfait ou remboursé : vous avez 30 jours pour changer d’avis.',
    CARDSBLOCK_MONTHLY_PAYMENT: 'Paiement mensuel sans engagement.',
    CARDSBLOCK_MONTHLY_TITLE: 'Abonnement mensuel',
    CARDSBLOCK_PERMONTH: '{{price}} / mois',
    CARDSBLOCK_SEEMORE: 'Voir plus d’abonnements'
  },
  subscriptions: {
    BASE: 'Abonnement',
    CANCEL_MODAL: {
      HEADLINE: 'Voulez-vous annuler le renouvellement automatique de votre abonnement ?',
      HINT: 'Votre abonnement sera toujours actif jusqu\'au {{date}} mais il ne sera pas renouvelé automatiquement.\nAprès cette date vous ne serez plus en mesure de localiser votre traceur.'
    },
    CHANGE_PLAN: {
      ADD_OPTIONS: 'Ajouter une option',
      EXPLANATION: 'Le changement d\'abonnement sera effectif à la fin de la période en cours.',
      HEADLINE: 'Changer d\'abonnement ?'
    },
    DETAILS: {
      ACTIVATE_BUTTON: {
        LABEL: 'Activer l\'abonnement'
      },
      ACTIVE_CASE: {
        MANAGE_BUTTON: 'Gérer l\'abonnement',
        RENEWAL_INFO: 'Votre abonnement sera renouvelé automatiquement le {{date}} au prix de {{price}}'
      },
      CANCELED: {
        EXPIRED_MAIN: 'Votre abonnement a expiré. Réactivez l\'abonnement pour pouvoir localiser votre traceur.',
        EXPIRED_SEC: 'Expiré',
        UNCANCEL_BUTTON_LABEL: 'Réactiver le renouvellement automatique de l\'abonnement',
        WILL_EXPIRE_DAYS: 'Expire dans {{count}} jour',
        WILL_EXPIRE_DAYS_plural: 'Expire dans {{count}} jours',
        WILL_EXPIRE_MAIN: 'Le renouvellement automatique de l\'abonnement a été annulé. Il expirera le {{date}}.'
      },
      CANCEL_RESILLIATION: 'Annuler la demande de résiliation',
      NEW_CASE: {
        INFO_TEXT: 'Nous rencontrons un problème avec votre paiement. Veuillez réessayer ou changer de moyen de paiement.',
        PAY_BUTTON: 'Payer et activer',
        WAITING_TEXT: 'Un paiement est en cours de validation pour l\'abonnement de ce traceur.'
      },
      NO_SUB: {
        INFO_TEXT: 'Activez l\'abonnement pour commencer à utiliser votre traceur.'
      },
      RESILLIATION_ASKED: 'Résiliation demandée',
      SUBSCRIBE_BUTTON: {
        LABEL: 'Prendre un abonnement'
      },
      SUPPORT_TEXT: 'Vous rencontrez des problèmes dans l\'activation de votre traceur ? Contactez l\'<1>assistance</1>.',
      TRIAL_PERIOD_CASE: {
        END_INFO: 'Votre période d\'essai prendra fin le {{ date }}'
      }
    },
    OFFERS: {
      SAVINGS: 'économisez {{price}}',
      SAVING_PER_YEAR: 'économisez {{amount}} / an'
    },
    OFFERS_TEXT: {
      MOST_POPULAR: 'La plus populaire',
      ONE_MONTH: {
        INFO: 'Sans engagement, résiliable à tout moment.',
        TITLE: 'Formule mensuelle'
      },
      ONE_YEAR: {
        INFO: 'Période d\'essai allongée de 15 jours : 30 jours au total',
        TITLE: 'Formule 1 an'
      },
      THREE_YEAR: {
        INFO: '1 an de garantie constructeur en plus : 3 ans au total \n',
        INFO2: 'Garantie constructeur de 3 ans (au lieu de deux)',
        TITLE: 'Formule 3 ans'
      }
    },
    OVERVIEW: {
      OPTIONS: 'Détails des options',
      REG_DETAILS: 'Détails du traceur',
      REPLACE_TRACKER_BUTTON: {
        LABEL: 'Remplacer le traceur'
      },
      SUB_DETAILS: 'Détails de l\'abonnement'
    },
    PLAN_NAMES: {
      FALLBACK: 'Abonnement',
      ONE_MONTH: 'Abonnement mensuel',
      ONE_YEAR: 'Abonnement prépayé 1 an',
      THREE_YEARS: 'Abonnement prépayé 3 ans',
      TRIAL_PERIOD: 'Période d\'essaie',
      TWO_YEARS: 'Abonnement 2 ans'
    },
    STATUS: {
      ACTIVE: 'Souscrit',
      CANCELED: 'Annulé',
      INACTIVE: 'Non-souscrit',
      NEW: 'Actif',
      PENDING: 'En attente'
    },
    TRACKER_DETAILS: {
      REGISTRATION_DATE: 'Date d\'activation',
      WARRANTY: 'Garantie standard'
    }
  },
  superLive: {
    ACTIVE_TEXT: 'Le mode superlive est activé',
    HEADLINE: 'Mode Super live',
    MESSAGES: {
      SUCCESS_ACTIVATED: 'Mode Super live activé avec succès - Une position toutes les {{frequency}} secondes pendant 5 minutes'
    },
    TIME: 'Une position toutes les {{frequency}} secondes'
  },
  support: {
    FORM: {
      MESSAGE: {
        LABEL: 'Votre message*',
        PLACEHOLDER: ''
      },
      PROBLEM: {
        AVAILABLE_OPTIONS: 'Options disponibles',
        LABEL: 'Type de problème rencontré*'
      },
      SUBJECT: {
        LABEL: 'Sujet de votre demande*',
        PLACEHOLDER: ''
      },
      TRACKER: {
        LABEL: 'Traceur concerné par votre demande',
        PLACEHOLDER: 'Sélectionnez le traceur'
      }
    },
    HEADLINE: 'Assistance',
    HELP_CENTER: 'Centre d’aide',
    HELP_TEXT: 'Besoin d\'aide ? Rendez-vous dans notre centre d\'aide pour trouver la réponse à votre question. Vous pouvez aussi nous contacter en utilisant le formulaire ci-dessous ; notre équipe vous répondra dans un délai de 24 heures ouvrées.',
    MAIN_TEXT: 'Notre centre d\'aide regroupe tous les articles pouvant apporter une réponse à vos questions.',
    MESSAGES: {
      SUBMIT_ERROR: 'Une erreur est survenue, veuillez réessayer',
      SUBMIT_SUCCESS: 'Message envoyé avec succès'
    },
    PROBLEM_TYPES: {
      CHARGE: 'Mon traceur ne se charge pas normalement',
      DOWNLOAD_APP: 'Je ne peux pas télécharger l\'application',
      GPS_INVALID: 'Mon signal GPS est indiqué invalide',
      GPS_PRECISION: 'La position GPS de mon traceur est incorrecte',
      LEDS_FIXED: 'Les deux leds de mon traceur restent fixes',
      NO_GEOFENCE_ALERTS: 'Je reçois de fausses alertes d\'entrée ou de sortie de zone',
      NO_NOTIFICATIONS: 'Je ne reçois pas les notifications',
      OTHER: 'Autre',
      SIGN_IN: 'Je n\'arrive pas à me connecter à mon espace personnel',
      SUBSCRIPTION: 'J\'ai un problème avec mon abonnement',
      TRACKERS_PARAMS: 'Je ne peux pas paramétrer mon traceur',
      TRACKER_NOT_CONNECTED: 'Mon traceur est indiqué non-connecté'
    },
    SUBMITTED_TICKET: 'Nous avons bien reçu votre demande, merci.\nUn email de confirmation vous a été envoyé (pensez à vérifier vos courriers indésirables).',
    SUB_TEXT: 'Si toutefois ces explications ne suffisaient pas, vous pouvez également contacter un membre de notre équipe SAV, qui vous répondra dans un délai de 24 heures ouvrées.',
    TITLE: 'Besoin d\'aide ?',
    URGENT_NUMBER: 'Si votre demande est urgente, vous pouvez contacter notre service client au \n+33 187 660 083 de 10h à 12h et de 14h à 17h du Lundi au Vendredi.'
  },
  trackerLeftPanel: {
    CALL: 'Appeler',
    CTR_ONLY_SECONDS: 'Il vous reste {{SECONDS}} seconde(s) d\'appel téléphonique pour le mois en cours.',
    CTR_WITH_MINUTES: 'Il vous reste {{MINUTES}} minute(s) et {{SECONDS}} seconde(s) d\'appel téléphonique pour le mois en cours.',
    FLASH: 'Lampe torche',
    GOOD_GPS_ACCURACY: 'Bonne précision GPS',
    LAST_POSITION: 'Dernière position connue :',
    MEDIUM_GPS_ACCURACY: 'Position GPS moyenne',
    OFFLINE: 'Traceur déconnecté',
    POOR_GPS_ACCURACY: 'Mauvaise précision GPS',
    RING: 'Sonnerie',
    SMS_AVAILABLE: 'SMS disponibles : {{SMS_count}}',
    VIBRATE: 'Vibreur'
  },
  trackerSettings: {
    BUTTONS: {
      LABELS: {
        BUTTON: 'Bouton'
      },
      PLACEHOLDER_BUTTON: 'Saisissez le message envoyé par le bouton {{button_number}}',
      TEXT: 'Configurez le message assigné à chaque bouton de votre traceur. Vous recevrez ce message si le bouton est pressé.'
    },
    CONTACTS: {
      ADD_EMAIL_BUTTON: 'Ajouter une adresse email',
      ADD_PHONE_BUTTON: 'Ajouter un numéro de téléphone',
      EMAILS_LABEL: 'Adresses email pour les notifications par email',
      MAIL: {
        PLACEHOLDER: 'votre@email.com'
      },
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu, veuillez réessayer.',
        UPDATE_SUCCESS: 'Contacts mis à jour avec succès'
      },
      NUMBERS_LABEL: 'Numéros de téléphone pour les notifications par SMS',
      PHONE: {
        PLACEHOLDER: '+33600000000'
      }
    },
    DISPLAY: {
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu',
        UPDATE_SUCCESS: 'Paramètres mis à jour avec succès'
      },
      MODAL: {
        HEADLINE: 'Sélectionnez l\'icône',
        TEXT: 'Vous pouvez sélectionner l\'icône que vous souhaitez dans la liste ci-dessous. Elle représentera votre traceur sur la carte.'
      },
      TRACKER_ICON: {
        EDIT_TEXT: 'Changer l\'icône',
        LABEL: 'Icône du traceur'
      },
      TRACKER_NAME: {
        LABEL: 'Nom du traceur',
        PLACEHOLDER: 'Nom qui s\'affichera sur la carte'
      },
      TRACKER_TYPE: {
        CHANGE: 'Changer le type',
        MODIFIED_SUCCESS: 'Type de traceur modifié avec succès'
      }
    },
    GENERAL_NAME_OF_THE_TRACKER: 'Nom du traceur',
    GENERAL_TITLE: 'Général',
    GPS_FREQUENCY: {
      '10MIN': '10min',
      '10S': '10s',
      '1MIN': '1min',
      '2MIN': '2min',
      '30S': '30s',
      '3MIN': '3min',
      '5MIN': '5min',
      BATTERY_USAGE: 'Autonomie moyenne de la batterie :',
      BATTERY_USAGE_LEVELS: {
        HIGH: 'Élevée',
        LOW: 'Faible',
        MEDIUM: 'Moyenne'
      },
      GEOFENCE_NOTIFICATIONS: 'Délai moyen de réactivité des alertes de zone :',
      HINT: 'Une fréquence plus rapide réduit l\'autonomie de la batterie mais améliore la réactivité des alertes d\'entrée et de sortie de zone. A l\'inverse, une fréquence plus lente améliore l\'autonomie de la batterie mais réduit la réactivité des alertes d\'entrée et de sortie de zone.',
      OFF: 'OFF',
      TEXT: 'Choisissez l\'intervalle de temps entre chaque position GPS'
    },
    NOTIFICATION_SETTINGS: {
      APP: 'Application',
      BATTERY: {
        HINT: 'Envoie une notification à tous les contacts lorsque le traceur atteint un niveau de batterie faible.',
        TITLE: 'Batterie'
      },
      BUTTONS: {
        HINT: 'Envoie une notification à tous les contacts dès que l\'un des boutons latéraux est pressé. Le message configuré pour ce bouton sera inclus dans la notification.',
        TITLE: 'Boutons latéraux'
      },
      GEOFENCES: {
        HINT: 'Envoie une notification à tous les contacts si le traceur entre ou sort d\'une zone paramétrée.',
        TITLE: 'Zones de sécurité'
      },
      MAIL: 'Mail',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu, veuillez réessayer',
        UPDATE_SUCCESS: 'Les paramètres de notifications ont été mis à jour avec succès'
      },
      POWERSAVINGAREA: {
        HINT: 'Envoie une notification à tous les contacts si le traceur entre ou sort d’une zone paramétrée.',
        TITLE: 'Zones d’économie d’énergie :'
      },
      SMS: 'SMS',
      SOS: {
        HINT: 'Envoie une notification à tous les contacts en cas de pression du bouton SOS.',
        TITLE: 'Appel SOS'
      },
      WARNING: {
        SMS: {
          LINK: 'Cliquez ici pour l\'activer.',
          TEXT: 'Attention, si vous souhaitez recevoir les alertes par SMS il vous faut activer l\'option correspondante.'
        }
      }
    },
    REDIRECTION_MESSAGE: 'Vous pouvez modifier ces paramètres à tout moment dans l’application mobile Weenect.',
    SECTION_TITLES: {
      BUTTONS: 'Boutons',
      CONTACTS: 'Contacts pour les notifications',
      DISPLAY: 'Général',
      GPS_FREQUENCY: 'Intervalle de temps entre chaque position GPS',
      NOTIFICATION_SETTINGS: 'Types de notifications pour chaque alerte',
      SOS: 'Numéro SOS',
      TRAINING: 'Appeler'
    },
    TRAINING_SOS: {
      DIRECT_CALL: 'Appeler directement ce numéro en cas d\'alerte SOS.',
      INPUT_PLACEHOLDER: '+33600000000',
      MESSAGES: {
        UPDATE_ERROR_UNKNOWN: 'Un problème est survenu, veuillez réessayer',
        UPDATE_SUCCESS: 'Numéro de téléphone mis à jour avec succès'
      },
      SOS_TEXT: 'Numéro de téléphone qui recevra les appels en cas d\'alerte SOS',
      TRAINING_TEXT: 'Renseignez le numéro de téléphone qui sera appelé par défaut par le traceur en cas d\'utilisation de la fonction téléphone depuis l\'application. Ce numéro est éditable à chaque demande d\'appel depuis l\'application.'
    }
  },
  trackerprofile: {
    AVATAR_PROMPT: 'Ajouter une photo',
    ERROR_REQUIRED: 'Ce champ est obligatoire',
    NAME_PLACEHOLDER: 'Donnez un nom à ce traceur',
    SUBMIT_CTA: 'Continuer',
    SUBTITLE: 'Quelques infos suffisent pour créer un profil qui lui ressemble',
    TITLE_ANIMAL: 'Personnalisez le profil de votre compagnon',
    TITLE_HUMAN: 'Personnalisez le profil de votre proche',
    TYPE_CAT: 'Chat',
    TYPE_CHILD: 'Enfant',
    TYPE_DOG: 'Chien',
    TYPE_ELDER: 'Personne âgée',
    TYPE_PLACEHOLDER: 'Sélectionnez le type de traceur'
  },
  trackerregistration: {
    ERROR_ALREADY_LINKED: 'Ce traceur est déjà relié à un compte',
    ERROR_INCOMPLETE: 'Le numéro IMEI doit faire 15 chiffres',
    ERROR_INVALID: 'Numéro IMEI invalide',
    SECTION_TITLE: 'Saisissez l\'identifiant du traceur',
    SUBMIT_CTA: 'Je valide le numéro d\'identification',
    SUBTITLE: 'Vous le trouverez au dos de votre traceur Weenect, il est composé de 15 chiffres'
  },
  trackers: {
    ADD_TRACKER_BUTTON: {
      LABEL: 'Ajouter un traceur'
    },
    EXPIRATION: {
      EXPIRED: 'L\'abonnement de {{tracker}} a expiré',
      WILL_EXPIRE: 'L\'abonnement de {{tracker}} va expirer dans {{days}} jours'
    },
    LINKS: {
      ACTIVITY: 'Suivi d\'activité',
      GEOFENCES: 'Zones',
      HISTORY: 'Historique',
      SETTINGS: 'Paramètres',
      SUBSCRIPTION: 'Abonnement'
    }
  },
  trackersPositionRefresh: {
    MESSAGES: {
      NOT_REFRESHED: 'Votre traceur n\'a pas réussi à acquérir de nouvelles positions GPS',
      REFRESHING: 'Veuillez patienter, une demande d\'actualisation est en cours.',
      SUCCESS: 'Position GPS du traceur mise à jour avec succès.'
    }
  },
  trackerstatus: {
    AIRPLANE: 'Traceur en mode avion',
    BATTERY_OFF: 'Traceur éteint car plus de batterie',
    GSM_BAD: 'Faible',
    GSM_GOOD: 'Bon',
    GSM_MEDIUM: 'Moyen',
    IN_AIRPLANE_MODE: 'En mode avion',
    IN_POWER_SAVING_AREA: 'En zone d\'économie d\'énergie',
    LAST_COMMUNICATION_AGO: 'Dernière communication il y a %s',
    LAST_COMMUNICATION_ON: 'Dernière position le %s',
    LAST_POSITION_AGO: 'Dernière position il y a %s',
    LAST_POSITION_ON: 'Dernière position le %s',
    NO_BATTERY: 'Plus de batterie',
    NO_POSITION: 'Aucune position connue',
    NO_SUBSCRIPTION: 'Pas d\'abonnement actif',
    OFFLINE: 'Traceur déconnecté',
    OFFLINE_GSM: 'Hors réseau GSM',
    OFFLINE_MANUAL: 'Éteint manuellement',
    ONLINE: 'Traceur connecté',
    POSITION_BAD: 'Faible',
    POSITION_GOOD: 'Bonne',
    POSITION_MEDIUM: 'Moyenne',
    POSITION_WIFI_NO_NAME: 'Non identifiée',
    TURN_OFF: 'Traceur éteint manuellement'
  },
  trackertab: {
    AIRPLANE_MODE_LABEL: 'Mode avion',
    NOTIFICATIONS_ALERT_BUTTONS_SUBTITLE: 'Consultez le message assigné aux boutons 2 et 3 de votre traceur. Vous recevrez ce message si le bouton est pressé.',
    NOTIFICATIONS_ALERT_BUTTONS_TITLE: 'Boutons d’alerte',
    NOTIFICATIONS_ALERT_ZONES_LABEL: 'Zones d\'alertes :',
    NOTIFICATIONS_BATTERY_LABEL: 'Batterie :',
    NOTIFICATIONS_BUTTON_2_LABEL: 'Bouton 2',
    NOTIFICATIONS_BUTTON_3_LABEL: 'Bouton 3',
    NOTIFICATIONS_CONTACTS_SUBTITLE: 'Contacts pour les notifications',
    NOTIFICATIONS_CREDITS_CALL: 'Il vous reste {{minutes}} minute(s) et {{seconds}} seconde(s) d’appel téléphonique pour le mois en cours.',
    NOTIFICATIONS_CREDITS_SMS: 'Il vous reste {{sms}} SMS pour le mois en cours.',
    NOTIFICATIONS_CREDITS_TITLE: 'Crédits restants',
    NOTIFICATIONS_EMAIL_ADDRESSES_LABEL: 'Adresses e-mail',
    NOTIFICATIONS_ENERGY_ZONES_LABEL: 'Zones d\'économie d\'énergie :',
    NOTIFICATIONS_PHONE_NUMBERS_LABEL: 'Numéros de téléphone',
    NOTIFICATIONS_SIDE_BUTTONS_LABEL: 'Boutons latéraux :',
    NOTIFICATIONS_SOS_CALL_LABEL: 'Appel SOS :',
    NOTIFICATIONS_TYPES_SUBTITLE: 'Types de notifications pour chaque alerte',
    PROFIL_ICON_LABEL: 'Icône du traceur',
    PROFIL_NAME_LABEL: 'Nom du traceur',
    PROFIL_SOS_PHONE_PLACEHOLDER: 'Numéro de téléphone qui recevra les appels SOS',
    PROFIL_SOS_PHONE_TITLE: 'Appel SOS',
    PROFIL_TRACKER_CAT: 'Traceur chat',
    PROFIL_TRACKER_CHILD: 'Traceur enfant',
    PROFIL_TRACKER_DOG: 'Traceur chien',
    PROFIL_TRACKER_ELDER: 'Traceur personne âgée',
    PROFIL_TYPE_LABEL: 'Type de traceur',
    ZONES_ALERTS_DANGER_SUBTITLE: 'Zones de danger',
    ZONES_ALERTS_MOBILE_ONLY_NOTE: 'La modification et la création de zones se font directement depuis l\'application mobile Weenect.',
    ZONES_ENERGY_MOBILE_ONLY_NOTE: 'La modification, la création de zones et l\'activation du mode avion se font directement depuis l\'application mobile Weenect.',
    ZONE_ACTIVE_STATE: 'Active',
    ZONE_INACTIVE_STATE: 'Désactivé'
  },
  transferPage: {
    ADD_TRACKER: 'Je souhaite ajouter un nouveau traceur à mon compte',
    BACK_TO_TRACKERS: 'Retour à la carte',
    FIRST_TITLE: 'Que souhaitez-vous faire exactement ?',
    FROM_HEADLINE: 'Traceur à remplacer :',
    HEADLINE: 'Remplacer un traceur',
    IMEI_LABEL: 'Numéro IMEI',
    INFO: 'L\'abonnement actuel et les paramètres seront transférés sur le nouveau traceur après le remplacement. L\'historique des positions GPS du précédent traceur sera perdu.',
    MESSAGES: {
      ERROR_UNKNOWN: 'Un problème est survenu, veuillez réessayer',
      SUCCESS: 'Nouveau traceur assigné avec succès',
      WRONG_TYPE: 'Le traceur avec ce numéro IMEI ne correspond pas au type de votre ancien traceur. Contactez notre service client.'
    },
    NAME_LABEL: 'Nom du traceur',
    PURCHASE: 'Vous n\'avez pas encore de traceur Weenect ? <1>Vous pouvez en acheter un ici</1>',
    REPLACE_BUTTON: {
      LABEL: 'Remplacer'
    },
    REPLACE_TRACKER: 'Je souhaite remplacer un traceur déjà existant',
    TO_HEADLINE: 'Nouveau traceur :'
  },
  translation: {
    account_payment_sepa_mandate: 'mandat SEPA'
  },
  webappDisconnection: {
    BUG: 'Non-connecté',
    MANUAL: 'Vous avez éteint votre traceur. Appuyez sur le bouton ON pour le rallumer.',
    NO_BATTERY: 'Your tracker has switched off because it ran out of battery power.',
    NO_SUB: 'Vous n’avez pas d’abonnement pour ce traceur. Veuillez en prendre un en allant sur la page'
  },
  weenectangels: {
    CARD_SEE_MORE: 'Voir plus',
    CARD_STATUS_LOST: 'PERDU',
    DETAIL_BREED: 'RACE',
    DETAIL_CHIPPED: 'PUCÉ',
    DETAIL_COLOR: 'COULEUR',
    DETAIL_CTA_WEBSITE: 'En savoir plus sur le site',
    DETAIL_EARS: 'OREILLES',
    DETAIL_FUR_DRAWING: 'ROBE',
    DETAIL_FUR_SIZE: 'POILS',
    DETAIL_GENDER: 'SEXE',
    DETAIL_INFO: 'Cette fonctionnalité peut être modifiée à tout moment depuis vos préférences. Cliquez ici pour y accéder',
    DETAIL_LOST_ON: 'Disparu le {{date}}',
    DETAIL_PHYSICAL_DESCRIPTION: 'DESCRIPTION PHYSIQUE',
    DETAIL_REPORTED_ON: 'Signalé sur {{site}}',
    DETAIL_SIZE: 'TAILLE',
    DETAIL_STATUS_LOST: 'PERDU',
    DETAIL_STERILIZED: 'STÉRILISÉ',
    DETAIL_TATTOOED: 'TATOUÉ'
  },
  wifiZones: {
    AIRPLANE_TEXT: 'Attention : En mode avion, tant que votre traceur se trouve dans la zone d\'économie d\'énergie, vous ne pouvez plus faire sonner, vibrer ou rafraîchir manuellement sa position.',
    DEEP_SLEEP_TITLE: 'Mode avion',
    DISPLAY_BUTTON: 'Afficher la zone sur la carte',
    DISPLAY_TITLE: 'Notifications',
    IN_AIRPLANE: '- en mode avion',
    IN_OUT_TEXT: 'Entrées et sorties de zone : ',
    LAST_POS_IN_WIFI: 'Dans la zone d\'économie d\'énergie depuis {{date}} ',
    MAIL_NOTIF: 'Notifications par e-mail',
    NOTIF_TEXT: 'Recevez une notification pour chaque entrée ou sortie de zone. ',
    POPIN: {
      AIRPLANE: {
        BUTTON_VALIDATE: 'Sortir du mode avion',
        CONTENT: 'Vous ne pouvez plus communiquer avec votre traceur tant qu’il est dans la zone d\'économie d\'énergie. Si vous souhaitez retrouver toutes les fonctionnalités,&nbsp;<strong>désactivez le mode avion et sortez le traceur de la zone</strong>.',
        TITLE: 'Votre traceur est en mode avion dans la zone d\'économie d\'énergie {{wifiName}}.'
      },
      BUTTON_CLOSE: 'Le faire plus tard',
      BUTTON_VALIDATE: 'Désactiver cette zone',
      CONTENT: 'Dans cette zone la remontée automatique des positions GPS de votre traceur est désactivée car nous savons qu\'il se trouve dans la zone. Vous pouvez désactiver cette zone à tout moment depuis l\'onglet "Traceur".',
      TITLE: 'Votre traceur est dans la zone d\'économie d’énergie {{wifiName}}'
    },
    PUSH_NOTIF: 'Notifications push',
    SMS_NOTIF: 'Notifications par SMS',
    TITLE: 'Zone d\'économie d\'énergie',
    ZONE_ACTIVATION: 'Activer la zone'
  }
}
